export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Hailuo 2.3 视频生成器 - 创新AI视频创作平台 | 微鲤AI',
        pageDescription:
            '体验Hailuo 2.3视频生成器，专注于智能视频创作和内容优化。采用先进深度学习技术，生成高质量、富有创意的视频内容。在WeryAI平台免费试用。',
        pageKeywords:
            'Hailuo 2.3, AI视频生成器, AI视频创作, 人工智能视频, 视频生成工具, 免费AI视频, 微鲤AI, 视频制作',

        // 生成器部分
        generatorTitle: 'Hailuo 2.3 视频生成器(MiniMax)',
        generatorDescription:
            'MiniMax Hailuo 2.3 是基于 Hailuo 02 模型的革命性升级，在<span class="highlight-bold">复杂肢体动作、多元风格化、人物微表情​​以及​​物体运动指令响应​​</span>方面实现了关键性突破，尤其擅长解决电商广告等商业场景中的产品动态展示难题，显著提升视频内容的质量与产出效率。<span class="highlight-bold">立即免费试用，体验下一代AI视频创作的强大魅力！</span>',
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Hailuo 2.3 核心功能',

        accurateInstructionFollowingTitle: '更精准的动态控制与真实画面​',
        accurateInstructionFollowingDescription:
            '模型对物理表现与指令遵循能力显著增强，可生成更加复杂、流畅且自然的人物肢体动作。在不同的大动态运镜下，光线、明暗过渡和色调都能实现近乎实拍的视觉效果，画面稳定性和精确度更高。',

        extremePhysicsMotionTitle: '更强大的多元风格化支持',
        extremePhysicsMotionDescription:
            '对动漫、插画、水墨、游戏CG等特殊画风的支持效果更佳。无论是通用模型还是特定风格，输出效果都更稳定、更生动，充分释放您的艺术创作潜力。',

        native1080pOutputTitle: '更细腻的人物微表情演绎',
        native1080pOutputDescription:
            '在Hailuo 2.3中，真人面部表演和微表情变化更加自然细腻。通过AI捕捉细微的表情变化，打造更具感染力和故事性的角色表演，让角色物栩栩如生。',

        costEffectiveTitle: '更出色的物体运动指令响应',
        costEffectiveDescription:
            '专为电商广告场景优化，对产品的运动指令响应更加出色。可高效解决产品移动、展示等难题，有效提升电商视频广告的“抽卡”成功率和专业度。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择Hailuo 2.3模型',
        step1Description:
            '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Hailuo 2.3"。',
        step2Title: '输入您的创意内容',
        step2Description:
            '描述您想要生成的内容，或上传图片进行转换，并选择您喜欢的风格和效果。',
        step3Title: '生成视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的高质量视频。',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: '1.Hailuo 2.3 相比之前的版本有哪些主要提升？',
        faq1Answer:
            'Hailuo 2.3 主要在四大方面实现提升：​肢体动作更复杂流畅、风格化支持更广更佳、人物微表情更细腻自然、对物体运动指令的响应更精准​​。这些提升共同使得生成的视频动态表现力更强，画面更真实稳定。',
        faq2Question: '2.Hailuo 2.3 适合用来制作什么类型的视频？​',
        faq2Answer:
            '它非常适合制作短视频内容、电商产品广告、动漫创作、游戏CG、艺术风格化短片等。特别是在需要精确控制产品运动或人物表情的电商和内容创作领域，表现出色。',
        faq3Question: '3.什么是 Hailuo 2.3 Fast 模型？它和标准版有什么区别？​',
        faq3Answer:
            'Hailuo 2.3 Fast 是一个优化了生成速度的模型版本，定价更低，速度更快，专为需要大批量生成视频、对成本敏感的用户设计。标准版则在极限画质和细节上可能更优。用户可根据项目需求灵活选择。',
        faq4Question: '4. 如何使用 Hailuo 2.3 模型？是否需要下载？​',
        faq4Answer:
            '无需下载。您可以直接访问海螺AI官网，在网页端或APP中即可选择使用Hailuo 2.3模型进行视频生成。开放平台开发者也可通过调用API接口集成该能力。',
        faq5Question: '5. 新用户是否有免费试用的机会？​',
        faq5Answer:
            '是的！在模型发布期间，我们每日为所有用户提供免费试用额度，您可以直接访问官网注册账号，无需付费即可立即体验Hailuo 2.3的强大功能。',
        faq6Question: '6. 如何获取 Hailuo 2.3 模型的 API 密钥？​',
        faq6Answer:
            'Media Agent（媒体智能体）是一个支持全模态创作的AI工具，它可以智能调用Hailuo 2.3等模型。您只需输入想法，它即可实现“​一键成片​​”，自动化完成视频剪辑，极大简化创作流程。它们是相辅相成的关系。',
        faq7Question: '7.Hailuo 2.3 的视频生成成本高吗？​',
        faq7Answer:
            'Hailuo 2.3 以“业界最优性价比”为目标，在提升效果的同时保持了原有价格。此外，通过选择Hailuo 2.3 Fast模型，还能进一步大幅降低批量创作的成本。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Hailuo 2.3，将您的创意转化为精彩视频',
        ctaDescription: '立即体验 Hailuo 2.3，将您的创意转化为精彩视频',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaNote: '无需信用卡',
        ctaDisclaimer: '无需信用卡',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
            youtubeTitle: '关于 Hailuo 2.3 视频模型的 YouTube 视频',
            youtubeVideosTitle: '关于 Hailuo 2.3 视频模型的 YouTube 视频',
            youtubeVideoTitle: '关于 Hailuo 2.3 视频模型的 YouTube 视频',
            xPostsTitle: '关于 Hailuo 2.3 视频模型的热门 X 贴文',
    },
    en: {
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - Innovative AI Video Creation Platform | 微鲤AI',
        pageDescription:
            'Experience Hailuo 2.3 video generator, focused on intelligent video creation and content optimization. Using advanced deep learning technology to generate high-quality, creative video content. Try it free on 微鲤AI platform.',
        pageKeywords:
            'Hailuo 2.3, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, 微鲤AI, video production',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator (MiniMax)',
        generatorDescription:
            'MiniMax Hailuo 2.3 is a revolutionary upgrade based on the Hailuo 02 model, achieving key breakthroughs in <span class="highlight-bold">complex body movements, diverse stylization, character micro-expressions, and object motion command response</span>. It excels particularly in solving product dynamic display challenges in commercial scenarios such as e-commerce advertising, significantly improving the quality and production efficiency of video content. <span class="highlight-bold">Try it free now and experience the powerful charm of next-generation AI video creation!</span>',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        accurateInstructionFollowingTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        accurateInstructionFollowingDescription:
            'The model has significantly enhanced its physical performance and instruction-following capabilities, enabling the generation of more complex, smooth, and natural human body movements. Under various large dynamic camera movements, light, shadow transitions, and color tones can achieve near-photorealistic visual effects, with higher image stability and precision.',

        extremePhysicsMotionTitle: 'More Powerful Diverse Stylization Support',
        extremePhysicsMotionDescription:
            "Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether it's a general model or a specific style, the output effects are more stable and vivid, fully unleashing your artistic creative potential.",

        native1080pOutputTitle:
            'More Detailed Character Micro-Expression Performance',
        native1080pOutputDescription:
            'In Hailuo 2.3, real human facial performance and micro-expression changes are more natural and detailed. Through AI capturing subtle expression changes, it creates more engaging and narrative character performances, making digital characters come to life.',

        costEffectiveTitle: 'Superior Object Motion Command Response',
        costEffectiveDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges such as product movement and display, effectively improving the "draw rate" and professionalism of e-commerce video advertisements.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Generate Video',
        step3Description:
            'Click "Create" to download or share the generated high-quality video as you wish.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',
        youtubeVideosTitle: 'YouTube Videos About Hailuo 2.3 Video Model',
        youtubeVideoTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question:
            '1. What are the main improvements in Hailuo 2.3 compared to previous versions?',
        faq1Answer:
            'Hailuo 2.3 has achieved improvements in four major areas: more complex and smooth body movements, broader and better stylization support, more detailed and natural character micro-expressions, and more precise response to object motion commands. These improvements together make the generated videos more dynamic and expressive, with more realistic and stable visuals.',
        faq2Question:
            '2. What types of videos is Hailuo 2.3 suitable for creating?',
        faq2Answer:
            'It is very suitable for creating short video content, e-commerce product advertisements, anime creation, game CG, artistic stylized short films, etc. It performs particularly well in e-commerce and content creation fields that require precise control of product movement or character expressions.',
        faq3Question:
            "3. What is the Hailuo 2.3 Fast model? What's the difference from the standard version?",
        faq3Answer:
            'Hailuo 2.3 Fast is a model version optimized for generation speed, with lower pricing and faster speed, designed specifically for users who need to generate videos in large quantities and are cost-sensitive. The standard version may be better in terms of extreme image quality and details. Users can flexibly choose based on project needs.',
        faq4Question:
            '4. How to use the Hailuo 2.3 model? Is downloading required?',
        faq4Answer:
            'No download required. You can directly visit the Hailuo AI official website and select the Hailuo 2.3 model for video generation on the web or in the APP. Open platform developers can also integrate this capability by calling API interfaces.',
        faq5Question: '5. Do new users have the opportunity to try for free?',
        faq5Answer:
            'Yes! During the model release period, we provide free trial credits daily for all users. You can directly visit the official website to register an account and immediately experience the powerful features of Hailuo 2.3 without payment.',
        faq6Question: '6. How to get the API key for the Hailuo 2.3 model?',
        faq6Answer:
            'Media Agent (media intelligence agent) is an AI tool that supports full-modal creation. It can intelligently call models such as Hailuo 2.3. You only need to input your ideas, and it can achieve "one-click video creation", automatically completing video editing, greatly simplifying the creation process. They complement each other.',
        faq7Question: '7. Is the video generation cost of Hailuo 2.3 high?',
        faq7Answer:
            'Hailuo 2.3 aims for "industry-leading cost-effectiveness", maintaining the original price while improving performance. In addition, by choosing the Hailuo 2.3 Fast model, you can further significantly reduce the cost of batch creation.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaNote: 'No credit card required',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    ja: {
        pageTitle: 'Hailuo 2.3 動画生成器 - 革新的なAI動画制作プラットフォーム | 微鲤AI',
        pageDescription: 'インテリジェントな動画制作とコンテンツ最適化に特化したHailuo 2.3動画生成器を体験してください。高度なディープラーニング技術を使用して、高品質でクリエイティブな動画コンテンツを生成します。WeryAIプラットフォームで無料でお試しください。',
        pageKeywords: 'Hailuo 2.3, AI動画生成器, AI動画制作, 人工知能動画, 動画生成ツール, 無料AI動画, 微鲤AI, 動画制作',
        generatorTitle: 'Hailuo 2.3 動画生成器 (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3は、Hailuo 02モデルをベースにした革命的なアップグレードであり、<span class="highlight-bold">複雑な身体の動き、多様なスタイリング、キャラクターの微細な表情、および物体の動きのコマンドレスポンス</span>において重要なブレークスルーを達成しました。特にEC広告などの商業シナリオにおける製品の動的表示の課題を解決することに優れており、動画コンテンツの品質と制作効率を大幅に向上させます。<span class="highlight-bold">今すぐ無料で試して、次世代のAI動画制作の強力な魅力を体験してください！</span>',
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',
        coreFeaturesTitle: 'Hailuo 2.3 核心機能',
        accurateInstructionFollowingTitle: 'より正確な動的制御とリアルな映像',
        accurateInstructionFollowingDescription: 'モデルの物理的パフォーマンスと命令フォロー機能が大幅に強化され、より複雑でスムーズ、かつ自然な人体の動きの生成が可能になりました。さまざまな大きな動的カメラワークの下でも、光、影の遷移、色調が実写に近い視覚効果を実現し、高い画像安定性と精度を誇ります。',
        extremePhysicsMotionTitle: 'より強力な多様なスタイリングサポート',
        extremePhysicsMotionDescription: 'アニメ、イラスト、水墨画、ゲームCGなどの特殊なアートスタイルのサポートが向上しました。汎用モデルでも特定のスタイルでも、出力効果はより安定して鮮やかになり、芸術的な創造の可能性を最大限に引き出します。',
        native1080pOutputTitle: 'より詳細なキャラクターの微細な表情表現',
        native1080pOutputDescription: 'Hailuo 2.3では、実際の人間の顔のパフォーマンスと微細な表情の変化がより自然で詳細になりました。AIが微細な表情の変化を捉えることで、より魅力的で物語性のあるキャラクターパフォーマンスを作成し、デジタルキャラクターに命を吹き込みます。',
        costEffectiveTitle: '優れた物体の動きコマンドレスポンス',
        costEffectiveDescription: 'EC広告シナリオ向けに特別に最適化されており、製品の動きのコマンドに対して優れたレスポンスを示します。製品の移動や表示などの課題を効率的に解決し、EC動画広告の「ドローレート」とプロ意識を効果的に向上させます。',
        howToUseTitle: '使用方法',
        howToUseSubtitle: '3つの簡単なステップで制作開始',
        step1Title: 'Hailuo 2.3モデルを選択',
        step1Description: '<span class="highlight-text">「AI動画生成」</span>ページに移動し、モデルドロップダウンメニューで「Hailuo 2.3」をクリックします。',
        step2Title: 'クリエイティブコンテンツを入力',
        step2Description: '生成したい内容を説明するか、変換用の画像をアップロードし、好みのスタイルと効果を選択します。',
        step3Title: '動画を生成',
        step3Description: '「作成」をクリックして、生成された高品質な動画を自由にダウンロードまたは共有してください。',
        youtubeTitle: 'Hailuo 2.3動画モデルに関するYouTube動画',
        youtubeVideosTitle: 'Hailuo 2.3動画モデルに関するYouTube動画',
        youtubeVideoTitle: 'Hailuo 2.3動画モデルに関するYouTube動画',
        xPostsTitle: 'Hailuo 2.3動画モデルに関する人気のX投稿',
        exploreModelsTitle: '他のモデルを探索',
        sora2Title: 'OpenAI Sora-2 AI 動画生成器',
        veo31Title: 'Google Veo 3.1 AI 動画生成器',
        veo3Title: 'Google Veo 3 AI 動画生成器',
        veo3FastTitle: 'Google Veo 3 Fast AI 動画生成器',
        klingTitle: 'Kling AI 動画生成器',
        runwayTitle: 'Runway AI 動画生成器',
        wanTitle: 'Wan AI 動画生成器',
        faqTitle: 'よくある質問',
        faq1Question: '1. Hailuo 2.3は以前のバージョンと比較してどのような主な改善点がありますか？',
        faq1Answer: 'Hailuo 2.3は、より複雑でスムーズな身体の動き、より広く優れたスタイリングサポート、より詳細で自然なキャラクターの微細な表情、および物体の動きのコマンドに対するより正確なレスポンスの4つの主要な分野で改善を達成しました。これらの改善により、生成された動画はよりダイナミックで表現力豊かになり、よりリアルで安定した映像になります。',
        faq2Question: '2. Hailuo 2.3はどのような種類の動画制作に適していますか？',
        faq2Answer: 'ショート動画コンテンツ、EC製品広告、アニメ制作、ゲームCG、芸術的なスタイリッシュな短編映画などの制作に非常に適しています。特に、製品の動きやキャラクターの表情を正確に制御する必要があるECやコンテンツ制作の分野で優れたパフォーマンスを発揮します。',
        faq3Question: '3. Hailuo 2.3 Fastモデルとは何ですか？標準バージョンとの違いは何ですか？',
        faq3Answer: 'Hailuo 2.3 Fastは生成速度を最適化したモデルバージョンで、価格が低く、速度が速く、動画を大量に生成する必要があり、コストに敏感なユーザー向けに特別に設計されています。標準バージョンは、極限の画質と詳細の点で優れている場合があります。ユーザーはプロジェクトのニーズに基づいて柔軟に選択できます。',
        faq4Question: '4. Hailuo 2.3モデルの使用方法は？ダウンロードは必要ですか？',
        faq4Answer: 'ダウンロードは不要です。Hailuo AIの公式ウェブサイトに直接アクセスし、ウェブまたはアプリで動画生成用のHailuo 2.3モデルを選択できます。オープンプラットフォームの開発者は、APIインターフェースを呼び出すことでこの機能を統合することもできます。',
        faq5Question: '5. 新規ユーザーには無料トライアルの機会がありますか？',
        faq5Answer: 'はい！モデルのリリース期間中、すべてのユーザーに毎日無料のトライアルクレジットを提供しています。公式ウェブサイトに直接アクセスしてアカウントを登録するだけで、支払うことなくHailuo 2.3の強力な機能をすぐに体験できます。',
        faq6Question: '6. Hailuo 2.3モデルのAPIキーを取得するにはどうすればよいですか？',
        faq6Answer: 'Media Agent（メディアインテリジェンスエージェント）は、フルモーダル制作をサポートするAIツールであり、Hailuo 2.3などのモデルをインテリジェントに呼び出すことができます。アイデアを入力するだけで、「ワンクリック動画制作」を実現し、動画編集を自動的に完了して、制作プロセスを大幅に簡素化できます。これらは互いに補完し合います。',
        faq7Question: '7. Hailuo 2.3の動画生成コストは高いですか？',
        faq7Answer: 'Hailuo 2.3は「業界をリードする費用対効果」を目指しており、パフォーマンスを向上させながら元の価格を維持しています。さらに、Hailuo 2.3 Fastモデルを選択することで、バッチ制作のコストをさらに大幅に削減できます。',
        ctaTitle: '制作を開始する準備はできましたか？',
        ctaSubtitle: '今すぐHailuo 2.3を体験して、あなたの創造性を素晴らしい動画に変えましょう',
        ctaDescription: '今すぐHailuo 2.3を体験して、あなたの創造性を素晴らしい動画に変えましょう',
        ctaButton: 'WeryAIでHailuo 2.3を試す',
        ctaNote: 'クレジットカード不要',
        ctaDisclaimer: 'クレジットカード不要',
        videoNotSupported: 'お使いのブラウザは動画の再生をサポートしていません',
        videoUnsupported: 'お使い of ブラウザは動画の再生をサポートしていません',
        videoLoadingError: '動画の読み込みに失敗しました',
        videoLoadError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
    },
    ko: {
        pageTitle: 'Hailuo 2.3 비디오 생성기 - 혁신적인 AI 비디오 제작 플랫폼 | 微鲤AI',
        pageDescription: '지능형 비디오 제작 및 콘텐츠 최적화에 중점을 둔 Hailuo 2.3 비디오 생성기를 경험해 보세요. 고급 딥 러닝 기술을 사용하여 고품질의 창의적인 비디오 콘텐츠를 생성합니다. 微鲤AI 플랫폼에서 무료로 체험해 보세요.',
        pageKeywords: 'Hailuo 2.3, AI 비디오 생성기, AI 비디오 제작, 인공지능 비디오, 비디오 생성 도구, 무료 AI 비디오, 微鲤AI, 비디오 제작',
        generatorTitle: 'Hailuo 2.3 비디오 생성기 (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3은 Hailuo 02 모델을 기반으로 한 혁신적인 업그레이드로, <span class="highlight-bold">복잡한 신체 움직임, 다양한 스타일화, 캐릭터 미세 표정 및 사물 동작 명령 반응</span> 분야에서 핵심적인 돌파구를 마련했습니다. 특히 이커머스 광고와 같은 상업적 시나리오에서 제품의 동적 전시 문제를 해결하는 데 탁월하며, 비디오 콘텐츠의 품질과 제작 효율성을 크게 향상시킵니다. <span class="highlight-bold">지금 무료로 체험하고 차세대 AI 비디오 제작의 강력한 매력을 경험해 보세요!</span>',
        tabImageToVideo: '이미지를 비디오로',
        tabTextToVideo: '텍스트를 비디오로',
        coreFeaturesTitle: 'Hailuo 2.3 핵심 기능',
        accurateInstructionFollowingTitle: '더욱 정밀한 동적 제어와 실감 나는 영상',
        accurateInstructionFollowingDescription: '모델의 물리적 표현 및 명령 준수 능력이 크게 향상되어 더욱 복잡하고 매끄러우며 자연스러운 인체 움직임을 생성할 수 있습니다. 다양한 역동적인 카메라 움직임 아래에서도 빛, 그림자 전환 및 색조가 실제 촬영에 가까운 시각적 효과를 구현하며 화면 안정성과 정밀도가 더 높습니다.',
        extremePhysicsMotionTitle: '더욱 강력해진 다양한 스타일화 지원',
        extremePhysicsMotionDescription: '애니메이션, 삽화, 수묵화, 게임 CG 등 특수 아트 스타일에 대한 지원이 향상되었습니다. 범용 모델이든 특정 스타일이든 출력 효과가 더 안정적이고 생생하여 예술적 창의력을 마음껏 발휘할 수 있습니다.',
        native1080pOutputTitle: '더욱 섬세해진 캐릭터 미세 표정 연출',
        native1080pOutputDescription: 'Hailuo 2.3에서는 실제 사람의 얼굴 연기와 미세 표정 변화가 더욱 자연스럽고 섬세해졌습니다. AI가 미세한 표정 변화를 포착하여 더욱 몰입감 있고 서사적인 캐릭터 연기를 만들어내며 디지털 캐릭터에 생명력을 불어넣습니다.',
        costEffectiveTitle: '탁월한 사물 동작 명령 반응',
        costEffectiveDescription: '이커머스 광고 시나리오에 맞게 특별히 최적화되어 사물 동작 명령에 대한 반응이 뛰어납니다. 제품 이동 및 전시 등의 문제를 효율적으로 해결하여 이커머스 비디오 광고의 "성공률"과 전문성을 효과적으로 향상시킵니다.',
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 세 단계로 제작 시작',
        step1Title: 'Hailuo 2.3 모델 선택',
        step1Description: '<span class="highlight-text">"AI 비디오 생성"</span> 페이지로 이동한 다음 모델 드롭다운 메뉴에서 "Hailuo 2.3"을 클릭합니다.',
        step2Title: '창의적인 콘텐츠 입력',
        step2Description: '생성하고 싶은 내용을 설명하거나 변환할 이미지를 업로드하고 원하는 스타일과 효과를 선택합니다.',
        step3Title: '비디오 생성',
        step3Description: '"생성"을 클릭하여 생성된 고품질 비디오를 원하는 대로 다운로드하거나 공유하세요.',
        youtubeTitle: 'Hailuo 2.3 비디오 모델에 대한 YouTube 비디오',
        youtubeVideosTitle: 'Hailuo 2.3 비디오 모델에 대한 YouTube 비디오',
        youtubeVideoTitle: 'Hailuo 2.3 비디오 모델에 대한 YouTube 비디오',
        xPostsTitle: 'Hailuo 2.3 비디오 모델에 대한 인기 X 게시물',
        exploreModelsTitle: '다른 모델 탐색',
        sora2Title: 'OpenAI Sora-2 AI 비디오 생성기',
        veo31Title: 'Google Veo 3.1 AI 비디오 생성기',
        veo3Title: 'Google Veo 3 AI 비디오 생성기',
        veo3FastTitle: 'Google Veo 3 Fast AI 비디오 생성기',
        klingTitle: 'Kling AI 비디오 생성기',
        runwayTitle: 'Runway AI 비디오 생성기',
        wanTitle: 'Wan AI 비디오 생성기',
        faqTitle: '자주 묻는 질문',
        faq1Question: '1. Hailuo 2.3은 이전 버전에 비해 어떤 주요 개선 사항이 있나요?',
        faq1Answer: 'Hailuo 2.3은 더욱 복잡하고 매끄러운 신체 움직임, 더 넓고 향상된 스타일화 지원, 더욱 섬세하고 자연스러운 캐릭터 미세 표정, 그리고 사물 동작 명령에 대한 더욱 정밀한 반응이라는 네 가지 주요 영역에서 개선을 이루었습니다. 이러한 개선 사항들이 합쳐져 생성된 비디오가 더욱 역동적이고 표현력이 풍부해졌으며, 더욱 실감 나고 안정적인 영상을 제공합니다.',
        faq2Question: '2. Hailuo 2.3은 어떤 유형의 비디오 제작에 적합한가요?',
        faq2Answer: '숏폼 비디오 콘텐츠, 이커머스 제품 광고, 애니메이션 제작, 게임 CG, 예술적인 스타일의 단편 영화 등을 제작하는 데 매우 적합합니다. 특히 제품의 움직임이나 캐릭터의 표정을 정밀하게 제어해야 하는 이커머스 및 콘텐츠 제작 분야에서 뛰어난 성능을 발휘합니다.',
        faq3Question: '3. Hailuo 2.3 Fast 모델은 무엇인가요? 표준 버전과 어떻게 다른가요?',
        faq3Answer: 'Hailuo 2.3 Fast는 생성 속도에 최적화된 모델 버전으로, 가격이 더 저렴하고 속도가 더 빨라 비디오를 대량으로 생성해야 하거나 비용에 민감한 사용자들을 위해 특별히 설계되었습니다. 표준 버전은 극한의 화질과 세부 사항 면에서 더 나을 수 있습니다. 사용자는 프로젝트 요구 사항에 따라 유연하게 선택할 수 있습니다.',
        faq4Question: '4. Hailuo 2.3 모델을 어떻게 사용하나요? 다운로드가 필요한가요?',
        faq4Answer: '다운로드가 필요하지 않습니다. Hailuo AI 공식 웹사이트를 직접 방문하여 웹이나 앱에서 비디오 생성을 위한 Hailuo 2.3 모델을 선택할 수 있습니다. 오픈 플랫폼 개발자들은 API 인터페이스를 호출하여 이 기능을 통합할 수도 있습니다.',
        faq5Question: '5. 신규 사용자에게 무료 체험 기회가 있나요?',
        faq5Answer: '네! 모델 출시 기간 동안 모든 사용자에게 매일 무료 체험 크레딧을 제공합니다. 공식 웹사이트를 직접 방문하여 계정을 등록하면 결제 없이 즉시 Hailuo 2.3의 강력한 기능을 경험해 볼 수 있습니다.',
        faq6Question: '6. Hailuo 2.3 모델의 API 키를 어떻게 얻나요?',
        faq6Answer: 'Media Agent(미디어 지능형 에이전트)는 모든 모달리티 제작을 지원하는 AI 도구로, Hailuo 2.3과 같은 모델을 지능적으로 호출할 수 있습니다. 아이디어만 입력하면 "원클릭 비디오 제작"을 구현하고 비디오 편집을 자동으로 완료하여 제작 프로세스를 크게 단순화할 수 있습니다. 서로 보완적인 관계입니다.',
        faq7Question: '7. Hailuo 2.3의 비디오 생성 비용이 높은가요?',
        faq7Answer: 'Hailuo 2.3은 성능을 향상시키면서도 원래 가격을 유지하여 "업계 최고의 가성비"를 목표로 합니다. 또한 Hailuo 2.3 Fast 모델을 선택하면 대량 제작 비용을 더욱 획기적으로 낮출 수 있습니다.',
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaSubtitle: '지금 바로 Hailuo 2.3을 경험하고 창의력을 멋진 비디오로 바꿔보세요',
        ctaDescription: '지금 바로 Hailuo 2.3을 경험하고 창의력을 멋진 비디오로 바꿔보세요',
        ctaButton: 'WeryAI에서 Hailuo 2.3 체험하기',
        ctaNote: '신용카드 필요 없음',
        ctaDisclaimer: '신용카드 필요 없음',
        videoNotSupported: '브라우저가 비디오 재생을 지원하지 않습니다',
        videoUnsupported: '브라우저가 비디오 재생을 지원하지 않습니다',
        videoLoadingError: '비디오 로딩 실패',
        videoLoadError: '비디오 로드 실패',
        videoReload: '새로고침',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'Hailuo 2.3 视频生成器 - 创新AI视频创作平台 | 微鲤AI',
        pageDescription:
            '体验Hailuo 2.3视频生成器，专注于智能视频创作和内容优化。采用先进深度学习技术，生成高质量、富有创意的视频内容。在WeryAI平台免费试用。',
        pageKeywords:
            'Hailuo 2.3, AI视频生成器, AI视频创作, 人工智能视频, 视频生成工具, 免费AI视频, 微鲤AI, 视频制作',

        // 生成器部分
        generatorTitle: 'Hailuo 2.3 视频生成器(MiniMax)',
        generatorDescription:
            'MiniMax Hailuo 2.3 是基于 Hailuo 02 模型的革命性升级，在<span class="highlight-bold">复杂肢体动作、多元风格化、人物微表情​​以及​​物体运动指令响应​​</span>方面实现了关键性突破，尤其擅长解决电商广告等商业场景中的产品动态展示难题，显著提升视频内容的质量与产出效率。<span class="highlight-bold">立即免费试用，体验下一代AI视频创作的强大魅力！</span>',
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Hailuo 2.3 核心功能',

        accurateInstructionFollowingTitle: '更精准的动态控制与真实画面​',
        accurateInstructionFollowingDescription:
            '模型对物理表现与指令遵循能力显著增强，可生成更加复杂、流畅且自然的人物肢体动作。在不同的大动态运镜下，光线、明暗过渡和色调都能实现近乎实拍的视觉效果，画面稳定性和精确度更高。',

        extremePhysicsMotionTitle: '更强大的多元风格化支持',
        extremePhysicsMotionDescription:
            '对动漫、插画、水墨、游戏CG等特殊画风的支持效果更佳。无论是通用模型还是特定风格，输出效果都更稳定、更生动，充分释放您的艺术创作潜力。',

        native1080pOutputTitle: '更细腻的人物微表情演绎',
        native1080pOutputDescription:
            '在Hailuo 2.3中，真人面部表演和微表情变化更加自然细腻。通过AI捕捉细微的表情变化，打造更具感染力和故事性的角色表演，让角色物栩栩如生。',

        costEffectiveTitle: '更出色的物体运动指令响应',
        costEffectiveDescription:
            '专为电商广告场景优化，对产品的运动指令响应更加出色。可高效解决产品移动、展示等难题，有效提升电商视频广告的“抽卡”成功率和专业度。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择Hailuo 2.3模型',
        step1Description:
            '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Hailuo 2.3"。',
        step2Title: '输入您的创意内容',
        step2Description:
            '描述您想要生成的内容，或上传图片进行转换，并选择您喜欢的风格和效果。',
        step3Title: '生成视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的高质量视频。',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: '1.Hailuo 2.3 相比之前的版本有哪些主要提升？',
        faq1Answer:
            'Hailuo 2.3 主要在四大方面实现提升：​肢体动作更复杂流畅、风格化支持更广更佳、人物微表情更细腻自然、对物体运动指令的响应更精准​​。这些提升共同使得生成的视频动态表现力更强，画面更真实稳定。',
        faq2Question: '2.Hailuo 2.3 适合用来制作什么类型的视频？​',
        faq2Answer:
            '它非常适合制作短视频内容、电商产品广告、动漫创作、游戏CG、艺术风格化短片等。特别是在需要精确控制产品运动或人物表情的电商和内容创作领域，表现出色。',
        faq3Question: '3.什么是 Hailuo 2.3 Fast 模型？它和标准版有什么区别？​',
        faq3Answer:
            'Hailuo 2.3 Fast 是一个优化了生成速度的模型版本，定价更低，速度更快，专为需要大批量生成视频、对成本敏感的用户设计。标准版则在极限画质和细节上可能更优。用户可根据项目需求灵活选择。',
        faq4Question: '4. 如何使用 Hailuo 2.3 模型？是否需要下载？​',
        faq4Answer:
            '无需下载。您可以直接访问海螺AI官网，在网页端或APP中即可选择使用Hailuo 2.3模型进行视频生成。开放平台开发者也可通过调用API接口集成该能力。',
        faq5Question: '5. 新用户是否有免费试用的机会？​',
        faq5Answer:
            '是的！在模型发布期间，我们每日为所有用户提供免费试用额度，您可以直接访问官网注册账号，无需付费即可立即体验Hailuo 2.3的强大功能。',
        faq6Question: '6. 如何获取 Hailuo 2.3 模型的 API 密钥？​',
        faq6Answer:
            'Media Agent（媒体智能体）是一个支持全模态创作的AI工具，它可以智能调用Hailuo 2.3等模型。您只需输入想法，它即可实现“​一键成片​​”，自动化完成视频剪辑，极大简化创作流程。它们是相辅相成的关系。',
        faq7Question: '7.Hailuo 2.3 的视频生成成本高吗？​',
        faq7Answer:
            'Hailuo 2.3 以“业界最优性价比”为目标，在提升效果的同时保持了原有价格。此外，通过选择Hailuo 2.3 Fast模型，还能进一步大幅降低批量创作的成本。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Hailuo 2.3，将您的创意转化为精彩视频',
        ctaDescription: '立即体验 Hailuo 2.3，将您的创意转化为精彩视频',
        ctaButton: 'Try Hailuo 2.3 on 微鲤AI',
        ctaNote: '无需信用卡',
        ctaDisclaimer: '无需信用卡',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
            youtubeTitle: '關於 Hailuo 2.3 影片模型的 YouTube 影片',
            youtubeVideosTitle: '關於 Hailuo 2.3 影片模型的 YouTube 影片',
            youtubeVideoTitle: '關於 Hailuo 2.3 影片模型的 YouTube 影片',
            xPostsTitle: '關於 Hailuo 2.3 影片模型的熱門 X 貼文',
    },
    pl: {
        pageTitle: 'Generator wideo Hailuo 2.3 - Innowacyjna platforma tworzenia wideo AI | 微鲤AI',
        pageDescription: 'Poznaj generator wideo Hailuo 2.3, skoncentrowany na inteligentnym tworzeniu wideo i optymalizacji treści. Wykorzystuje zaawansowaną technologię głębokiego uczenia do generowania wysokiej jakości, kreatywnych treści wideo. Wypróbuj za darmo na platformie 微鲤AI.',
        pageKeywords: 'Hailuo 2.3, generator wideo AI, tworzenie wideo AI, wideo ze sztuczną inteligencją, narzędzie do generowania wideo, darmowe wideo AI, 微鲤AI, produkcja wideo',
        generatorTitle: 'Generator wideo Hailuo 2.3 (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3 to rewolucyjna aktualizacja oparta na modelu Hailuo 02, osiągająca kluczowe przełomy w <span class="highlight-bold">złożonych ruchach ciała, różnorodnej stylizacji, mikromimice postaci i odpowiedzi na polecenia ruchu obiektów</span>. <span class="highlight-bold">Wypróbuj teraz za darmo i poczuj potężny urok tworzenia wideo AI nowej generacji!</span>',
        tabImageToVideo: 'Obraz na wideo',
        tabTextToVideo: 'Tekst na wideo',
        coreFeaturesTitle: 'Kluczowe funkcje Hailuo 2.3',
        accurateInstructionFollowingTitle: 'Precyzyjniejsza kontrola dynamiczna i realistyczny obraz',
        accurateInstructionFollowingDescription: 'Model znacząco poprawił wydajność fizyczną.',
        extremePhysicsMotionTitle: 'Potężniejsze wsparcie dla różnorodnej stylizacji',
        extremePhysicsMotionDescription: 'Lepsze wsparcie dla specjalnych stylów artystycznych.',
        native1080pOutputTitle: 'Bardziej szczegółowe oddanie mikromimiki postaci',
        native1080pOutputDescription: 'Zmiany mikromimiki są bardziej naturalne.',
        costEffectiveTitle: 'Doskonała odpowiedź na polecenia ruchu obiektów',
        costEffectiveDescription: 'Zoptymalizowany pod kątem reklam.',
        howToUseTitle: 'Jak używać',
        howToUseSubtitle: 'Trzy proste kroki, aby zacząć tworzyć',
        step1Title: 'Wybierz model Hailuo 2.3',
        step1Description: 'Przejdź do strony <span class="highlight-text">"Generowanie wideo AI"</span>.',
        step2Title: 'Wprowadź swoją kreatywną treść',
        step2Description: 'Opisz, co chcesz wygenerować.',
        step3Title: 'Wygeneruj wideo',
        step3Description: 'Kliknij "Utwórz".',
        youtubeTitle: 'Filmy na YouTube o modelu wideo Hailuo 2.3',
        youtubeVideosTitle: 'Filmy na YouTube o modelu wideo Hailuo 2.3',
        youtubeVideoTitle: 'Filmy na YouTube o modelu wideo Hailuo 2.3',
        xPostsTitle: 'Popularne posty na X o modelu wideo Hailuo 2.3',
        exploreModelsTitle: 'Poznaj inne modele',
        sora2Title: 'Generator wideo OpenAI Sora-2 AI',
        veo31Title: 'Generator wideo Google Veo 3.1 AI',
        veo3Title: 'Generator wideo Google Veo 3 AI',
        veo3FastTitle: 'Generator wideo Google Veo 3 Fast AI',
        klingTitle: 'Generator wideo Kling AI',
        runwayTitle: 'Generator wideo Runway AI',
        wanTitle: 'Generator wideo Wan AI',
        faqTitle: 'Często zadawane pytania',
        faq1Question: '1. Jakie są główne ulepszenia?',
        faq1Answer: 'Ulepszenia w czterech głównych obszarach.',
        faq2Question: '2. Do jakich typów filmów nadaje się?',
        faq2Answer: 'E-commerce, anime, itp.',
        faq3Question: '3. Co to jest model Hailuo 2.3 Fast?',
        faq3Answer: 'Zoptymalizowany pod kątem szybkości.',
        faq4Question: '4. Jak korzystać z modelu?',
        faq4Answer: 'Odwiedź stronę.',
        faq5Question: '5. Czy nowi użytkownicy mają możliwość wypróbowania?',
        faq5Answer: 'Tak.',
        faq6Question: '6. Jak uzyskać klucz API?',
        faq6Answer: 'Media Agent.',
        faq7Question: '7. Czy koszt jest wysoki?',
        faq7Answer: 'Najlepszy stosunek jakości do ceny.',
        ctaTitle: 'Gotowy, aby zacząć tworzyć?',
        ctaSubtitle: 'Wypróbuj Hailuo 2.3 już teraz',
        ctaDescription: 'Wypróbuj Hailuo 2.3 już teraz',
        ctaButton: 'Wypróbuj Hailuo 2.3 na 微鲤AI',
        ctaNote: 'Karta kredytowa nie jest wymagana',
        ctaDisclaimer: 'Karta kredytowa nie jest wymagana',
        videoNotSupported: 'Browser nie obsługuje odtwarzania',
        videoUnsupported: 'Browser nie obsługuje odtwarzania',
        videoLoadingError: 'Błąd ładowania',
        videoLoadError: 'Nie udało się załadować',
        videoReload: 'Odśwież',
    },
    es: {
        pageTitle: 'Generador de Video Hailuo 2.3 - Plataforma Innovadora de Creación de Video IA | 微鲤AI',
        pageDescription: 'Experimente el generador de video Hailuo 2.3, enfocado en la creación inteligente de video y la optimización de contenido. Utilizando tecnología avanzada de aprendizaje profundo para generar contenido de video creativo y de alta calidad. Pruébelo gratis en la plataforma 微鲤AI.',
        pageKeywords: 'Hailuo 2.3, generador de video IA, creación de video IA, video de inteligencia artificial, herramienta de generación de video, video IA gratis, 微鲤AI, producción de video',
        generatorTitle: 'Generador de Video Hailuo 2.3 (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3 es una actualización revolucionaria basada en el modelo Hailuo 02, logrando avances clave en <span class="highlight-bold">movimientos corporales complejos, estilización diversa, microexpresiones de personajes y respuesta a comandos de movimiento de objetos</span>. Destaca particularmente en resolver desafíos de exhibición dinámica de productos en escenarios comerciales como la publicidad de comercio electrónico, mejorando significativamente la calidad y la eficiencia de producción del contenido de video. <span class="highlight-bold">¡Pruébelo gratis ahora y experimente el poderoso encanto de la creación de video IA de próxima generación!</span>',
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',
        coreFeaturesTitle: 'Características Principales de Hailuo 2.3',
        accurateInstructionFollowingTitle: 'Control Dinámico Más Preciso y Visuales Realistas',
        accurateInstructionFollowingDescription: 'El modelo ha mejorado significativamente su rendimiento físico y sus capacidades de seguimiento de instrucciones, permitiendo la generación de movimientos del cuerpo humano más complejos, suaves y naturales. Bajo varios movimientos de cámara dinámicos amplios, la luz, las transiciones de sombras y los tonos de color pueden lograr efectos visuales casi fotorrealistas, con mayor estabilidad y precisión de imagen.',
        extremePhysicsMotionTitle: 'Soporte de Estilización Diversa Más Potente',
        extremePhysicsMotionDescription: 'Mejor soporte para estilos artísticos especiales como anime, ilustración, pintura con tinta y CG de juegos. Ya sea un modelo general o un estilo específico, los efectos de salida son más estables y vívidos, liberando completamente su potencial creativo artístico.',
        native1080pOutputTitle: 'Interpretación de Microexpresiones de Personajes Más Detallada',
        native1080pOutputDescription: 'En Hailuo 2.3, el rendimiento facial humano real y los cambios de microexpresión son más naturales y detallados. A través de la IA que captura cambios sutiles en la expresión, crea interpretaciones de personajes más atractivas y narrativas, haciendo que los personajes digitales cobren vida.',
        costEffectiveTitle: 'Respuesta Superior a Comandos de Movimiento de Objetos',
        costEffectiveDescription: 'Optimizado específicamente para escenarios publicitarios de comercio electrónico, con una excelente respuesta a los comandos de movimiento de productos. Resuelve eficientemente desafíos como el movimiento y la exhibición de productos, mejorando efectivamente la "tasa de acierto" y el profesionalismo de los anuncios de video de comercio electrónico.',
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres simples pasos para empezar a crear',
        step1Title: 'Seleccione el Modelo Hailuo 2.3',
        step1Description: 'Vaya a la página de <span class="highlight-text">"Generación de Video IA"</span>, luego haga clic en "Hailuo 2.3" en el menú desplegable de modelos.',
        step2Title: 'Ingrese su Contenido Creativo',
        step2Description: 'Describa lo que desea generar, o suba imágenes para conversión, y elija sus estilos y efectos preferidos.',
        step3Title: 'Generar Video',
        step3Description: 'Haga clic en "Crear" para descargar o compartir el video de alta calidad generado como desee.',
        youtubeTitle: 'Videos de YouTube Sobre el Modelo de Video Hailuo 2.3',
        youtubeVideosTitle: 'Videos de YouTube Sobre el Modelo de Video Hailuo 2.3',
        youtubeVideoTitle: 'Videos de YouTube Sobre el Modelo de Video Hailuo 2.3',
        xPostsTitle: 'Publicaciones Populares de X Sobre el Modelo de Video Hailuo 2.3',
        exploreModelsTitle: 'Explorar Otros Modelos',
        sora2Title: 'Generador de Video OpenAI Sora-2 IA',
        veo31Title: 'Generador de Video Google Veo 3.1 IA',
        veo3Title: 'Generador de Video Google Veo 3 IA',
        veo3FastTitle: 'Generador de Video Google Veo 3 Fast IA',
        klingTitle: 'Generador de Video Kling IA',
        runwayTitle: 'Generador de Video Runway IA',
        wanTitle: 'Generador de Video Wan IA',
        faqTitle: 'Preguntas Frecuentes',
        faq1Question: '1. ¿Cuáles son las principales mejoras en Hailuo 2.3 en comparación con las versiones anteriores?',
        faq1Answer: 'Hailuo 2.3 ha logrado mejoras en cuatro áreas principales: movimientos corporales más complejos y suaves, soporte de estilización más amplio y mejor, microexpresiones de personajes más detalladas y naturales, y una respuesta más precisa a los comandos de movimiento de objetos. Estas mejoras juntas hacen que los videos generados sean más dinámicos y expresivos, con visuales más realistas y estables.',
        faq2Question: '2. ¿Para qué tipos de videos es adecuado crear Hailuo 2.3?',
        faq2Answer: 'Es muy adecuado para crear contenido de video corto, anuncios de productos de comercio electrónico, creación de anime, CG de juegos, cortometrajes estilizados artísticamente, etc. Funciona particularmente bien en los campos de comercio electrónico y creación de contenido que requieren un control preciso del movimiento del producto o las expresiones de los personajes.',
        faq3Question: '3. ¿Qué es el modelo Hailuo 2.3 Fast? ¿Cuál es la diferencia con la versión estándar?',
        faq3Answer: 'Hailuo 2.3 Fast es una versión del modelo optimizada para la velocidad de generación, con precios más bajos y mayor velocidad, diseñada específicamente para usuarios que necesitan generar videos en grandes cantidades y son sensibles al costo. La versión estándar puede ser mejor en términos de calidad de imagen extrema y detalles. Los usuarios pueden elegir de manera flexible según las necesidades del proyecto.',
        faq4Question: '4. ¿Cómo usar el modelo Hailuo 2.3? ¿Es necesario descargarlo?',
        faq4Answer: 'No requiere descarga. Puede visitar directamente el sitio web oficial de Hailuo AI y seleccionar el modelo Hailuo 2.3 para la generación de video en la web o en la aplicación. Los desarrolladores de plataformas abiertas también pueden integrar esta capacidad llamando a las interfaces API.',
        faq5Question: '5. ¿Tienen los nuevos usuarios la oportunidad de probarlo gratis?',
        faq5Answer: '¡Sí! Durante el período de lanzamiento del modelo, proporcionamos créditos de prueba gratuitos diariamente para todos los usuarios. Puede visitar directamente el sitio web oficial para registrar una cuenta y experimentar de inmediato las poderosas funciones de Hailuo 2.3 sin pagar.',
        faq6Question: '6. ¿Cómo obtener la clave API para el modelo Hailuo 2.3?',
        faq6Answer: 'Media Agent (agente de inteligencia de medios) es una herramienta de IA que admite la creación de modo completo. Puede llamar de forma inteligente a modelos como Hailuo 2.3. Solo necesita ingresar sus ideas y puede lograr una "creación de video en un clic", completando automáticamente la edición de video, simplificando enormemente el proceso de creación. Se complementan entre sí.',
        faq7Question: '7. ¿Es alto el costo de generación de video de Hailuo 2.3?',
        faq7Answer: 'Hailuo 2.3 apunta a la "mejor relación costo-beneficio de la industria", manteniendo el precio original mientras mejora el rendimiento. Además, al elegir el modelo Hailuo 2.3 Fast, puede reducir aún más significativamente el costo de la creación por lotes.',
        ctaTitle: '¿Listo para Empezar a Crear?',
        ctaSubtitle: 'Experimente Hailuo 2.3 ahora y transforme su creatividad en videos increíbles',
        ctaDescription: 'Experimente Hailuo 2.3 ahora y transforme su creatividad en videos increíbles',
        ctaButton: 'Pruebe Hailuo 2.3 en 微鲤AI',
        ctaNote: 'No se requiere tarjeta de crédito',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',
        videoNotSupported: 'Su navegador no admite la reproducción de video',
        videoUnsupported: 'Su navegador no admite la reproducción de video',
        videoLoadingError: 'Error al cargar el video',
        videoLoadError: 'El video no se pudo cargar',
        videoReload: 'Recargar',
    },
    fr: {
        pageTitle: 'Générateur de Vidéo Hailuo 2.3 - Plateforme Innovante de Création Vidéo IA | 微鲤AI',
        pageDescription: 'Découvrez le générateur de vidéo Hailuo 2.3, axé sur la création vidéo intelligente et l\'optimisation de contenu. Utilisant une technologie avancée d\'apprentissage profond pour générer du contenu vidéo créatif et de haute qualité. Essayez-le gratuitement sur la plateforme 微鲤AI.',
        pageKeywords: 'Hailuo 2.3, générateur vidéo IA, création vidéo IA, vidéo intelligence artificielle, outil de génération vidéo, vidéo IA gratuite, 微鲤AI, production vidéo',
        generatorTitle: 'Générateur de Vidéo Hailuo 2.3 (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3 est une mise à niveau révolutionnaire basée sur le modèle Hailuo 02, réalisant des percées clés dans les <span class="highlight-bold">mouvements corporels complexes, la stylisation diversifiée, les micro-expressions des personnages et la réponse aux commandes de mouvement d\'objets</span>. Il excelle particulièrement dans la résolution des défis d\'affichage dynamique des produits dans des scénarios commerciaux tels que la publicité e-commerce, améliorant considérablement la qualité et l\'efficacité de production du contenu vidéo. <span class="highlight-bold">Essayez-le gratuitement maintenant et découvrez le charme puissant de la création vidéo IA de nouvelle génération !</span>',
        tabImageToVideo: 'Image en Vidéo',
        tabTextToVideo: 'Texte en Vidéo',
        coreFeaturesTitle: 'Caractéristiques Principales de Hailuo 2.3',
        accurateInstructionFollowingTitle: 'Contrôle Dynamique Plus Précis et Visuels Réalistes',
        accurateInstructionFollowingDescription: 'Le modèle a considérablement amélioré ses performances physiques et ses capacités de suivi d\'instructions, permettant la génération de mouvements du corps humain plus complexes, fluides et naturels. Sous divers grands mouvements de caméra dynamiques, la lumière, les transitions d\'ombre et les tons de couleur peuvent obtenir des effets visuels proches du photoréalisme, avec une stabilité et une précision d\'image accrues.',
        extremePhysicsMotionTitle: 'Support de Stylisation Diversifiée Plus Puissant',
        extremePhysicsMotionDescription: 'Meilleur support pour les styles artistiques spéciaux tels que l\'anime, l\'illustration, la peinture à l\'encre et le CG de jeu. Qu\'il s\'agisse d\'un modèle général ou d\'un style spécifique, les effets de sortie sont plus stables et vifs, libérant pleinement votre potentiel créatif artistique.',
        native1080pOutputTitle: 'Interprétation de Micro-Expressions de Personnages Plus Détaillée',
        native1080pOutputDescription: 'Dans Hailuo 2.3, les performances faciales humaines réelles et les changements de micro-expression sont plus naturels et détaillés. Grâce à l\'IA capturant les changements d\'expression subtils, elle crée des performances de personnages plus engageantes et narratives, donnant vie aux personnages numériques.',
        costEffectiveTitle: 'Réponse Supérieure aux Commandes de Mouvement d\'Objets',
        costEffectiveDescription: 'Optimisé spécifiquement pour les scénarios publicitaires e-commerce, avec une excellente réponse aux commandes de mouvement de produits. Il résout efficacement les défis tels que le mouvement et l\'affichage des produits, améliorant efficacement le "taux de réussite" et le professionnalisme des publicités vidéo e-commerce.',
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples pour commencer à créer',
        step1Title: 'Sélectionnez le Modèle Hailuo 2.3',
        step1Description: 'Allez sur la page <span class="highlight-text">"Génération Vidéo IA"</span>, puis cliquez sur "Hailuo 2.3" dans le menu déroulant des modèles.',
        step2Title: 'Entrez Votre Contenu Créatif',
        step2Description: 'Décrivez ce que vous souhaitez générer, ou téléchargez des images pour la conversion, et choisissez vos styles et effets préférés.',
        step3Title: 'Générer la Vidéo',
        step3Description: 'Cliquez sur "Créer" pour télécharger ou partager la vidéo de haute qualité générée comme vous le souhaitez.',
        youtubeTitle: 'Vidéos YouTube sur le Modèle Vidéo Hailuo 2.3',
        youtubeVideosTitle: 'Vidéos YouTube sur le Modèle Vidéo Hailuo 2.3',
        youtubeVideoTitle: 'Vidéos YouTube sur le Modèle Vidéo Hailuo 2.3',
        xPostsTitle: 'Publications Populaires sur X concernant le Modèle Vidéo Hailuo 2.3',
        exploreModelsTitle: 'Explorer d\'autres modèles',
        sora2Title: 'Générateur Vidéo OpenAI Sora-2 IA',
        veo31Title: 'Générateur Vidéo Google Veo 3.1 IA',
        veo3Title: 'Générateur Vidéo Google Veo 3 IA',
        veo3FastTitle: 'Générateur Vidéo Google Veo 3 Fast IA',
        klingTitle: 'Générateur Vidéo Kling IA',
        runwayTitle: 'Générateur Vidéo Runway IA',
        wanTitle: 'Générateur Vidéo Wan IA',
        faqTitle: 'Foire Aux Questions',
        faq1Question: '1. Quelles sont les principales améliorations de Hailuo 2.3 par rapport aux versions précédentes ?',
        faq1Answer: 'Hailuo 2.3 a réalisé des améliorations dans quatre domaines majeurs : des mouvements corporels plus complexes et fluides, un support de stylisation plus large et meilleur, des micro-expressions de personnages plus détaillées et naturelles, et une réponse plus précise aux commandes de mouvement d\'objets. Ces améliorations contribuent ensemble à rendre les vidéos générées plus dynamiques et expressives, avec des visuels plus réalistes et stables.',
        faq2Question: '2. Quels types de vidéos Hailuo 2.3 est-il adapté à créer ?',
        faq2Answer: 'Il est très adapté à la création de contenu vidéo court, de publicités pour produits e-commerce, de création d\'anime, de CG de jeu, de courts métrages stylisés artistiquement, etc. Il est particulièrement performant dans les domaines de l\'e-commerce et de la création de contenu qui nécessitent un contrôle précis du mouvement des produits ou des expressions des personnages.',
        faq3Question: '3. Qu\'est-ce que le modèle Hailuo 2.3 Fast ? Quelle est la différence par rapport à la version standard ?',
        faq3Answer: 'Hailuo 2.3 Fast est une version du modèle optimisée pour la vitesse de génération, avec des tarifs inférieurs et une vitesse accrue, conçue spécifiquement pour les utilisateurs qui ont besoin de générer des vidéos en grandes quantités et qui sont sensibles aux coûts. La version standard peut être meilleure en termes de qualité d\'image extrême et de détails.',
        faq4Question: '4. Comment utiliser le modèle Hailuo 2.3 ? Un téléchargement est-il requis ?',
        faq4Answer: 'Aucun téléchargement requis. Vous pouvez visiter directement le site officiel de Hailuo AI et sélectionner le modèle Hailuo 2.3 pour la génération vidéo sur le Web ou dans l\'APP.',
        faq5Question: '5. Les nouveaux utilisateurs ont-ils la possibilité d\'essayer gratuitement ?',
        faq5Answer: 'Oui ! Pendant la période de lancement du modèle, nous fournissons quotidiennement des crédits d\'essai gratuits pour tous les utilisateurs. Vous pouvez visiter directement le site officiel pour créer un compte.',
        faq6Question: '6. Comment obtenir la clé API pour le modèle Hailuo 2.3 ?',
        faq6Answer: 'Media Agent est un outil IA qui prend en charge la création en mode complet. Il peut appeler intelligemment des modèles tels que Hailuo 2.3. Il vous suffit de saisir vos idées.',
        faq7Question: '7. Le coût de génération vidéo de Hailuo 2.3 est-il élevé ?',
        faq7Answer: 'Hailuo 2.3 vise le "meilleur rapport qualité-prix de l\'industrie".',
        ctaTitle: 'Prêt à commencer à créer ?',
        ctaSubtitle: 'Découvrez Hailuo 2.3 maintenant',
        ctaDescription: 'Découvrez Hailuo 2.3 maintenant',
        ctaButton: 'Essayer Hailuo 2.3 sur 微鲤AI',
        ctaNote: 'Aucune carte de crédit requise',
        ctaDisclaimer: 'Aucune carte de crédit requise',
        videoNotSupported: 'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoUnsupported: 'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadingError: 'Échec du chargement de la vidéo',
        videoLoadError: 'La vidéo n\'a pas pu être chargée',
        videoReload: 'Recharger',
    },
    de: {
        pageTitle: 'Hailuo 2.3 Videogenerator – Innovative KI-Videoproduktionsplattform | 微鲤AI',
        pageDescription: 'Erleben Sie den Hailuo 2.3 Videogenerator, spezialisiert auf intelligente Videoproduktion und Inhaltsoptimierung. Nutzt fortschrittliche Deep-Learning-Technologie zur Erstellung hochwertiger, kreativer Videoinhalte. Kostenlos testen auf der 微鲤AI-Plattform.',
        pageKeywords: 'Hailuo 2.3, KI-Videogenerator, KI-Videoproduktion, Künstliche Intelligenz Video, Videogenerierungstool, kostenlose KI-Videos, 微鲤AI, Videoproduktion',
        generatorTitle: 'Hailuo 2.3 Videogenerator (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3 ist ein revolutionäres Upgrade basierend auf dem Hailuo 02-Modell, das entscheidende Durchbrüche bei <span class="highlight-bold">komplexen Körperbewegungen, vielfältiger Stilisierung, Mikro-Mimik von Charakteren und der Reaktion auf Objektbewegungsbefehle</span> erzielt. <span class="highlight-bold">Jetzt kostenlos testen und den kraftvollen Charme der KI-Videoproduktion der nächsten Generation erleben!</span>',
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',
        coreFeaturesTitle: 'Hauptmerkmale von Hailuo 2.3',
        accurateInstructionFollowingTitle: 'Präzisere dynamische Steuerung und realistische Optik',
        accurateInstructionFollowingDescription: 'Das Modell hat seine physikalische Leistung und seine Fähigkeiten zur Befolgung von Anweisungen erheblich verbessert.',
        extremePhysicsMotionTitle: 'Stärkerer Support für vielfältige Stilisierung',
        extremePhysicsMotionDescription: 'Bessere Unterstützung für spezielle Kunststile wie Anime, Illustration, Tuschemalerei und Game CG.',
        native1080pOutputTitle: 'Detailliertere Darstellung von Charakter-Mikromimik',
        native1080pOutputDescription: 'In Hailuo 2.3 wirken echte menschliche Gesichtsdarstellungen und Mikro-Mimikänderungen natürlicher.',
        costEffectiveTitle: 'Hervorragende Reaktion auf Objektbewegungsbefehle',
        costEffectiveDescription: 'Speziell für E-Commerce-Werbeszenarien optimiert.',
        howToUseTitle: 'Anwendung',
        howToUseSubtitle: 'Drei einfache Schritte bis zur Kreation',
        step1Title: 'Hailuo 2.3 Modell auswählen',
        step1Description: 'Gehen Sie zur Seite <span class="highlight-text">„KI-Videogenerierung“</span>.',
        step2Title: 'Kreativen Inhalt eingeben',
        step2Description: 'Beschreiben Sie, was Sie generieren möchten.',
        step3Title: 'Video generieren',
        step3Description: 'Klicken Sie auf „Erstellen“.',
        youtubeTitle: 'YouTube-Videos über das Hailuo 2.3 Videomodell',
        youtubeVideosTitle: 'YouTube-Videos über das Hailuo 2.3 Videomodell',
        youtubeVideoTitle: 'YouTube-Videos über das Hailuo 2.3 Videomodell',
        xPostsTitle: 'Beliebte X-Posts über das Hailuo 2.3 Videomodell',
        exploreModelsTitle: 'Andere Modelle erkunden',
        sora2Title: 'OpenAI Sora-2 KI-Videogenerator',
        veo31Title: 'Google Veo 3.1 KI-Videogenerator',
        veo3Title: 'Google Veo 3 KI-Videogenerator',
        veo3FastTitle: 'Google Veo 3 Fast KI-Videogenerator',
        klingTitle: 'Kling KI-Videogenerator',
        runwayTitle: 'Runway KI-Videogenerator',
        wanTitle: 'Wan KI-Videogenerator',
        faqTitle: 'Häufig gestellte Fragen',
        faq1Question: '1. Was sind die wichtigsten Verbesserungen in Hailuo 2.3?',
        faq1Answer: 'Verbesserungen in vier Hauptbereichen.',
        faq2Question: '2. Für welche Arten von Videos ist Hailuo 2.3 geeignet?',
        faq2Answer: 'E-Commerce, Anime, Game CG usw.',
        faq3Question: '3. Was ist das Hailuo 2.3 Fast-Modell?',
        faq3Answer: 'Auf Geschwindigkeit optimiert.',
        faq4Question: '4. Wie verwende ich das Hailuo 2.3 Modell?',
        faq4Answer: 'Besuchen Sie die Website.',
        faq5Question: '5. Haben neue Nutzer die Möglichkeit zum kostenlosen Testen?',
        faq5Answer: 'Ja.',
        faq6Question: '6. Wie erhalte ich den API-Schlüssel?',
        faq6Answer: 'Media Agent nutzen.',
        faq7Question: '7. Sind die Kosten hoch?',
        faq7Answer: 'Beste Preis-Leistungs-Verhältnis.',
        ctaTitle: 'Bereit für den Start?',
        ctaSubtitle: 'Erleben Sie Hailuo 2.3 jetzt',
        ctaDescription: 'Erleben Sie Hailuo 2.3 jetzt',
        ctaButton: 'Hailuo 2.3 auf 微鲤AI testen',
        ctaNote: 'Keine Kreditkarte erforderlich',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',
        videoNotSupported: 'Browser unterstützt Videowiedergabe nicht',
        videoUnsupported: 'Browser unterstützt Videowiedergabe nicht',
        videoLoadingError: 'Laden fehlgeschlagen',
        videoLoadError: 'Fehler beim Laden',
        videoReload: 'Neu laden',
    },
    ru: {
        pageTitle: 'Видеогенератор Hailuo 2.3 — инновационная платформа для создания ИИ-видео | 微鲤AI',
        pageDescription: 'Попробуйте видеогенератор Hailuo 2.3, ориентированный на интеллектуальное создание видео и оптимизацию контента. Использование передовых технологий глубокого обучения для создания высококачественного креативного видеоконтента. Попробуйте бесплатно на платформе 微鲤AI.',
        pageKeywords: 'Hailuo 2.3, ИИ видеогенератор, создание ИИ видео, видео с искусственным интеллектом, инструмент генерации видео, бесплатное ИИ видео, 微鲤AI, видеопроизводство',
        generatorTitle: 'Видеогенератор Hailuo 2.3 (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3 — это революционное обновление на базе модели Hailuo 02, обеспечивающее ключевые прорывы в <span class="highlight-bold">сложных движениях тела, разнообразной стилизации, микромимике персонажей и реакции на команды перемещения объектов</span>. <span class="highlight-bold">Попробуйте бесплатно прямо сейчас и испытайте мощное очарование создания ИИ-видео следующего поколения!</span>',
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',
        coreFeaturesTitle: 'Основные характеристики Hailuo 2.3',
        accurateInstructionFollowingTitle: 'Более точное динамическое управление и реалистичные визуальные эффекты',
        accurateInstructionFollowingDescription: 'Модель значительно улучшила свои физические показатели и возможности следования инструкциям.',
        extremePhysicsMotionTitle: 'Более мощная поддержка разнообразной стилизации',
        extremePhysicsMotionDescription: 'Улучшенная поддержка специальных стилей искусства, таких как аниме, иллюстрация, живопись тушью и игровая компьютерная графика.',
        native1080pOutputTitle: 'Более детальное исполнение микромимики персонажей',
        native1080pOutputDescription: 'В Hailuo 2.3 исполнение человеческих лиц и изменения микромимики стали более естественными.',
        costEffectiveTitle: 'Превосходная реакция на команды перемещения объектов',
        costEffectiveDescription: 'Специально оптимизировано для рекламных сценариев электронной коммерции.',
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Три простых шага, чтобы начать творить',
        step1Title: 'Выберите модель Hailuo 2.3',
        step1Description: 'Перейдите на страницу <span class="highlight-text">«Генерация ИИ-видео»</span>.',
        step2Title: 'Введите ваш творческий контент',
        step2Description: 'Опишите то, что вы хотите создать.',
        step3Title: 'Сгенерировать видео',
        step3Description: 'Нажмите «Создать».',
        youtubeTitle: 'Видео на YouTube о видеомодели Hailuo 2.3',
        youtubeVideosTitle: 'Видео на YouTube о видеомодели Hailuo 2.3',
        youtubeVideoTitle: 'Видео на YouTube о видеомодели Hailuo 2.3',
        xPostsTitle: 'Популярные посты в X о видеомодели Hailuo 2.3',
        exploreModelsTitle: 'Изучить другие модели',
        sora2Title: 'OpenAI Sora-2 ИИ видеогенератор',
        veo31Title: 'Google Veo 3.1 ИИ видеогенератор',
        veo3Title: 'Google Veo 3 ИИ видеогенератор',
        veo3FastTitle: 'Google Veo 3 Fast ИИ видеогенератор',
        klingTitle: 'Kling ИИ видеогенератор',
        runwayTitle: 'Runway ИИ видеогенератор',
        wanTitle: 'Wan ИИ видеогенератор',
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: '1. Каковы основные улучшения в Hailuo 2.3?',
        faq1Answer: 'Улучшения в четырех основных областях.',
        faq2Question: '2. Для каких типов видео подходит создание Hailuo 2.3?',
        faq2Answer: 'E-commerce, аниме, CG и т.д.',
        faq3Question: '3. Что такое модель Hailuo 2.3 Fast?',
        faq3Answer: 'Оптимизированная по скорости.',
        faq4Question: '4. Как использовать модель Hailuo 2.3?',
        faq4Answer: 'Посетите сайт.',
        faq5Question: '5. Есть ли у новых пользователей возможность бесплатного тестирования?',
        faq5Answer: 'Да.',
        faq6Question: '6. Как получить ключ API?',
        faq6Answer: 'Media Agent.',
        faq7Question: '7. Высока ли стоимость?',
        faq7Answer: 'Лучшее соотношение цены и качества.',
        ctaTitle: 'Готовы начать творить?',
        ctaSubtitle: 'Попробуйте Hailuo 2.3 сейчас',
        ctaDescription: 'Попробуйте Hailuo 2.3 сейчас',
        ctaButton: 'Попробовать Hailuo 2.3 на 微鲤AI',
        ctaNote: 'Кредитная карта не требуется',
        ctaDisclaimer: 'Кредитная карта не требуется',
        videoNotSupported: 'Браузер не поддерживает воспроизведение',
        videoUnsupported: 'Браузер не поддерживает воспроизведение',
        videoLoadingError: 'Ошибка загрузки',
        videoLoadError: 'Не удалось загрузить',
        videoReload: 'Перезагрузить',
    },
    pt: {
        pageTitle: 'Gerador de Vídeo Hailuo 2.3 - Plataforma Inovadora de Criação de Vídeo IA | 微鲤AI',
        pageDescription: 'Experimente o gerador de vídeo Hailuo 2.3, focado na criação inteligente de vídeo e otimização de conteúdo. Utilizando tecnologia avançada de aprendizagem profunda para gerar conteúdo de vídeo criativo e de alta qualidade. Experimente grátis na plataforma 微鲤AI.',
        pageKeywords: 'Hailuo 2.3, gerador de vídeo IA, criação de vídeo IA, vídeo de inteligência artificial, ferramenta de geração de vídeo, vídeo IA grátis, 微鲤AI, produção de vídeo',
        generatorTitle: 'Gerador de Vídeo Hailuo 2.3 (MiniMax)',
        generatorDescription: 'O MiniMax Hailuo 2.3 é uma atualização revolucionária baseada no modelo Hailuo 02, alcançando avanços fundamentais em <span class="highlight-bold">movimentos corporais complexos, estilização diversificada, microexpressões de personagens e resposta a comandos de movimento de objetos</span>. <span class="highlight-bold">Experimente grátis agora e sinta o charme poderoso da criação de vídeo IA de próxima geração!</span>',
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',
        coreFeaturesTitle: 'Principais Características do Hailuo 2.3',
        accurateInstructionFollowingTitle: 'Controle Dinâmico Mais Preciso e Visuais Realistas',
        accurateInstructionFollowingDescription: 'O modelo melhorou significativamente seu desempenho físico.',
        extremePhysicsMotionTitle: 'Suporte de Estilização Diversificada Mais Potente',
        extremePhysicsMotionDescription: 'Melhor suporte para estilos artísticos especiais.',
        native1080pOutputTitle: 'Interpretação de Microexpressões de Personagens Mais Detalhada',
        native1080pOutputDescription: 'Mudanças de microexpressão são mais naturais.',
        costEffectiveTitle: 'Resposta Superior a Comandos de Movimento de Objetos',
        costEffectiveDescription: 'Otimizado para cenários publicitários.',
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples para começar a criar',
        step1Title: 'Selecione o Modelo Hailuo 2.3',
        step1Description: 'Vá para a página de <span class="highlight-text">"Geração de Vídeo IA"</span>.',
        step2Title: 'Insira o seu Conteúdo Criativo',
        step2Description: 'Descreva o que deseja gerar.',
        step3Title: 'Gerar Vídeo',
        step3Description: 'Clique em "Criar".',
        youtubeTitle: 'Vídeos do YouTube sobre o Modelo de Vídeo Hailuo 2.3',
        youtubeVideosTitle: 'Vídeos do YouTube sobre o Modelo de Vídeo Hailuo 2.3',
        youtubeVideoTitle: 'Vídeos do YouTube sobre o Modelo de Vídeo Hailuo 2.3',
        xPostsTitle: 'Publicações Populares no X sobre o Modelo de Vídeo Hailuo 2.3',
        exploreModelsTitle: 'Explorar Outros Modelos',
        sora2Title: 'Gerador de Vídeo OpenAI Sora-2 IA',
        veo31Title: 'Gerador de Vídeo Google Veo 3.1 IA',
        veo3Title: 'Gerador de Vídeo Google Veo 3 IA',
        veo3FastTitle: 'Gerador de Vídeo Google Veo 3 Fast IA',
        klingTitle: 'Gerador de Vídeo Kling IA',
        runwayTitle: 'Gerador de Vídeo Runway IA',
        wanTitle: 'Gerador de Vídeo Wan IA',
        faqTitle: 'Perguntas Frequentes',
        faq1Question: '1. Quais são as principais melhorias?',
        faq1Answer: 'Melhorias em quatro áreas.',
        faq2Question: '2. Para que tipos de vídeos é adequado?',
        faq2Answer: 'E-commerce, anime, etc.',
        faq3Question: '3. O que é o modelo Hailuo 2.3 Fast?',
        faq3Answer: 'Otimizado para velocidade.',
        faq4Question: '4. Como usar o modelo Hailuo 2.3?',
        faq4Answer: 'Visite o site.',
        faq5Question: '5. Os novos utilizadores têm a oportunidade de experimentar?',
        faq5Answer: 'Sim.',
        faq6Question: '6. Como obter a chave API?',
        faq6Answer: 'Usar Media Agent.',
        faq7Question: '7. O custo é elevado?',
        faq7Answer: 'Melhor relação custo-benefício.',
        ctaTitle: 'Pronto para começar?',
        ctaSubtitle: 'Experimente Hailuo 2.3 agora',
        ctaDescription: 'Experimente Hailuo 2.3 agora',
        ctaButton: 'Experimente o Hailuo 2.3 no 微鲤AI',
        ctaNote: 'Nenhum cartão de crédito necessário',
        ctaDisclaimer: 'Nenhum cartão de crédito necessário',
        videoNotSupported: 'Navegador não suporta reprodução',
        videoUnsupported: 'Navegador não suporta reprodução',
        videoLoadingError: 'Falha ao carregar',
        videoLoadError: 'Erro ao carregar',
        videoReload: 'Recarregar',
    },
    it: {
        pageTitle: 'Generatore Video Hailuo 2.3 - Piattaforma Innovativa di Creazione Video AI | 微鲤AI',
        pageDescription: 'Scopri il generatore video Hailuo 2.3, focalizzato sulla creazione video intelligente e l\'ottimizzazione dei contenuti. Utilizza tecnologie avanzate di deep learning per generare contenuti video creativi e di alta qualità. Provalo gratuitamente sulla piattaforma 微鲤AI.',
        pageKeywords: 'Hailuo 2.3, generatore video AI, creazione video AI, video intelligenza artificiale, strumento generazione video, video AI gratuito, 微鲤AI, produzione video',
        generatorTitle: 'Generatore Video Hailuo 2.3 (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3 è un aggiornamento rivoluzionario basato sul modello Hailuo 02, che realizza scoperte chiave nei <span class="highlight-bold">movimenti corporei complessi, nella stilizzazione diversificata, nelle micro-espressioni dei personaggi e nella risposta ai comandi di movimento degli oggetti</span>. <span class="highlight-bold">Provalo subito gratuitamente e sperimenta il potente fascino della creazione video AI di prossima generazione!</span>',
        tabImageToVideo: 'Da Immagine a Video',
        tabTextToVideo: 'Da Testo a Video',
        coreFeaturesTitle: 'Caratteristiche Principali di Hailuo 2.3',
        accurateInstructionFollowingTitle: 'Controllo Dinamico Più Preciso e Grafica Realistica',
        accurateInstructionFollowingDescription: 'Il modello ha notevolmente migliorato le prestazioni fisiche.',
        extremePhysicsMotionTitle: 'Supporto per Stilizzazione Diversificata Più Potente',
        extremePhysicsMotionDescription: 'Migliore supporto per stili artistici speciali.',
        native1080pOutputTitle: 'Interpretazione delle Micro-espressioni dei Personaggi Più Dettagliata',
        native1080pOutputDescription: 'Cambiamenti delle micro-espressioni sono più naturali.',
        costEffectiveTitle: 'Risposta Superiore ai Comandi di Movimento degli Oggetti',
        costEffectiveDescription: 'Ottimizzato per scenari pubblicitari.',
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passaggi per iniziare a creare',
        step1Title: 'Seleziona il Modello Hailuo 2.3',
        step1Description: 'Vai alla pagina <span class="highlight-text">"Generazione Video AI"</span>.',
        step2Title: 'Inserisci il Tuo Contenuto Creativo',
        step2Description: 'Descrivi ciò che desideri generare.',
        step3Title: 'Genera Video',
        step3Description: 'Fai clic su "Crea".',
        youtubeTitle: 'Video di YouTube sul Modello Video Hailuo 2.3',
        youtubeVideosTitle: 'Video di YouTube sul Modello Video Hailuo 2.3',
        youtubeVideoTitle: 'Video di YouTube sul Modello Video Hailuo 2.3',
        xPostsTitle: 'Post Popolari su X riguardo al Modello Video Hailuo 2.3',
        exploreModelsTitle: 'Esplora altri modelli',
        sora2Title: 'Generatore Video OpenAI Sora-2 AI',
        veo31Title: 'Generatore Video Google Veo 3.1 AI',
        veo3Title: 'Generatore Video Google Veo 3 AI',
        veo3FastTitle: 'Generatore Video Google Veo 3 Fast AI',
        klingTitle: 'Generatore Video Kling AI',
        runwayTitle: 'Generatore Video Runway AI',
        wanTitle: 'Generatore Video Wan AI',
        faqTitle: 'Domande Frequenti',
        faq1Question: '1. Quali sono i principali miglioramenti?',
        faq1Answer: 'Miglioramenti in quattro aree.',
        faq2Question: '2. Per quali tipi di video è adatta?',
        faq2Answer: 'E-commerce, anime, ecc.',
        faq3Question: '3. Cos\'è il modello Hailuo 2.3 Fast?',
        faq3Answer: 'Ottimizzato per la velocità.',
        faq4Question: '4. Come si usa il modello Hailuo 2.3?',
        faq4Answer: 'Visita il sito.',
        faq5Question: '5. I nuovi utenti hanno l\'opportunità di provare?',
        faq5Answer: 'Sì.',
        faq6Question: '6. Come ottenere la chiave API?',
        faq6Answer: 'Usare Media Agent.',
        faq7Question: '7. Il costo è elevato?',
        faq7Answer: 'Miglior rapporto qualità-prezzo.',
        ctaTitle: 'Pronto per iniziare?',
        ctaSubtitle: 'Prova subito Hailuo 2.3',
        ctaDescription: 'Prova subito Hailuo 2.3',
        ctaButton: 'Prova Hailuo 2.3 su 微鲤AI',
        ctaNote: 'Nessuna carta di credito richiesta',
        ctaDisclaimer: 'Nessuna carta di credito richiesta',
        videoNotSupported: 'Browser non supporta riproduzione',
        videoUnsupported: 'Browser non supporta riproduzione',
        videoLoadingError: 'Caricamento fallito',
        videoLoadError: 'Errore caricamento',
        videoReload: 'Ricarica',
    },
    ar: {
        pageTitle: 'مولد الفيديو Hailuo 2.3 - منصة ابتكارية لإنشاء الفيديو بالذكاء الاصطناعي | 微鲤AI',
        pageDescription: 'استمتع بتجربة مولد الفيديو Hailuo 2.3، الذي يركز على إنشاء الفيديو الذكي وتحسين المحتوى. استخدام تقنية التعلم العميق المتقدمة لإنشاء محتوى видео عالي الجودة ومبتكر. جربه مجانًا على منصة 微鲤AI.',
        pageKeywords: 'Hailuo 2.3، مولد فيديو ذكاء اصطناعي، إنشاء فيديو ذكاء اصطناعي، فيديو ذكاء اصطناعي، أداة توليد الفيديو، فيديو ذكاء اصطناعي مجاني، 微鲤AI، إنتاج الفيديو',
        generatorTitle: 'مولد الفيديو Hailuo 2.3 (MiniMax)',
        generatorDescription: 'يُعد MiniMax Hailuo 2.3 ترقية ثورية تعتمد على نموذج Hailuo 02، حيث حقق اختراقات رئيسية في <span class="highlight-bold">حركات الجسم المعقدة، والأساليب المتنوعة، وتعبيرات وجه الشخصيات الدقيقة، والاستجابة لأوامر حركة الأشياء</span>. <span class="highlight-bold">جربه مجانًا الآن واستمتع بالسحر القوي للجيل القادم من إنشاء الفيديو بالذكاء الاصطناعي!</span>',
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',
        coreFeaturesTitle: 'الميزات الرئيسية لـ Hailuo 2.3',
        accurateInstructionFollowingTitle: 'تحكم ديناميكي أكثر دقة ومرئيات واقعية',
        accurateInstructionFollowingDescription: 'عزز النموذج بشكل كبير أداءه الفيزيائي.',
        extremePhysicsMotionTitle: 'دعم أقوى للأساليب المتنوعة',
        extremePhysicsMotionDescription: 'دعم أفضل للأنماط الفنية الخاصة.',
        native1080pOutputTitle: 'أداء تعبيرات وجه الشخصيات الدقيقة الأكثر تفصيلاً',
        native1080pOutputDescription: 'تغيرات التعبيرات الدقيقة أكثر طبيعية.',
        costEffectiveTitle: 'استجابة فائقة لأوامر حركة الأشياء',
        costEffectiveDescription: 'مُحسَّن لإعلانات التجارة الإلكترونية.',
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة لبدء الإبداع',
        step1Title: 'اختر نموذج Hailuo 2.3',
        step1Description: 'انتقل إلى صفحة <span class="highlight-text">"توليد فيديو بالذكاء الاصطناعي"</span>.',
        step2Title: 'أدخل محتواك الإبداعي',
        step2Description: 'صف ما تريد توليده.',
        step3Title: 'توليد الفيديو',
        step3Description: 'انقر فوق "إنشاء".',
        youtubeTitle: 'فيديوهات يوتيوب حول نموذج فيديو Hailuo 2.3',
        youtubeVideosTitle: 'فيديوهات يوتيوب حول نموذج فيديو Hailuo 2.3',
        youtubeVideoTitle: 'فيديوهات يوتيوب حول نموذج فيديو Hailuo 2.3',
        xPostsTitle: 'منشورات X الشائعة حول نموذج فيديو Hailuo 2.3',
        exploreModelsTitle: 'استكشاف نماذج أخرى',
        sora2Title: 'مولد الفيديو OpenAI Sora-2 بالذكاء الاصطناعي',
        veo31Title: 'مولد الفيديو Google Veo 3.1 بالذكاء الاصطناعي',
        veo3Title: 'مولد الفيديو Google Veo 3 بالذكاء الاصطناعي',
        veo3FastTitle: 'مولد الفيديو Google Veo 3 Fast بالذكاء الاصطناعي',
        klingTitle: 'مولد الفيديو Kling بالذكاء الاصطناعي',
        runwayTitle: 'مولد الفيديو Runway بالذكاء الاصطناعي',
        wanTitle: 'مولد الفيديو Wan بالذكاء الاصطناعي',
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: '1. ما هي التحسينات الرئيسية؟',
        faq1Answer: 'تحسينات في أربعة مجالات.',
        faq2Question: '2. ما هي أنواع الفيديوهات التي يصلح إنشاؤها؟',
        faq2Answer: 'تجارة إلكترونية، أنمي، إلخ.',
        faq3Question: '3. ما هو نموذج Hailuo 2.3 Fast؟',
        faq3Answer: 'مُحسَّن للسرعة.',
        faq4Question: '4. كيفية استخدام نموذج Hailuo 2.3؟',
        faq4Answer: 'زيارة الموقع.',
        faq5Question: '5. هل تتاح فرصة التجربة المجانية؟',
        faq5Answer: 'نعم.',
        faq6Question: '6. كيف أحصل على مفتاح API؟',
        faq6Answer: 'استخدام Media Agent.',
        faq7Question: '7. هل التكلفة مرتفعة؟',
        faq7Answer: 'أفضل فعالية من حيث التكلفة.',
        ctaTitle: 'هل أنت مستعد لبدء الإبداع؟',
        ctaSubtitle: 'جرب Hailuo 2.3 الآن',
        ctaDescription: 'جرب Hailuo 2.3 الآن',
        ctaButton: 'جرب Hailuo 2.3 على 微鲤AI',
        ctaNote: 'لا يتطلب بطاقة ائتمان',
        ctaDisclaimer: 'لا يتطلب بطاقة ائتمان',
        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoUnsupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadingError: 'فشل تحميل الفيديو',
        videoLoadError: 'تعذر تحميل الفيديو',
        videoReload: 'إعادة التحميل',
    },
    th: {
        pageTitle: 'Hailuo 2.3 Video Generator - แพลตฟอร์มสร้างวิดีโอ AI นวัตกรรมใหม่ | 微鲤AI',
        pageDescription: 'สัมผัสประสบการณ์เครื่องมือสร้างวิดีโอ Hailuo 2.3 ที่เน้นการสร้างวิดีโออัจฉริยะและการเพิ่มประสิทธิภาพเนื้อหา ใช้เทคโนโลยี Deep Learning ขั้นสูงเพื่อสร้างเนื้อหาวิดีโอที่สร้างสรรค์และมีคุณภาพสูง ทดลองใช้ฟรีบนแพลตฟอร์ม 微鲤AI',
        pageKeywords: 'Hailuo 2.3, เครื่องมือสร้างวิดีโอ AI, การสร้างวิดีโอ AI, วิดีโอปัญญาประดิษฐ์, เครื่องมือสร้างวิดีโอ, วิดีโอ AI ฟรี, 微鲤AI, การผลิตวิดีโอ',
        generatorTitle: 'เครื่องมือสร้างวิดีโอ Hailuo 2.3 (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3 เป็นการอัปเกรดที่ปฏิวัติวงการจากรุ่น Hailuo 02 โดยบรรลุความก้าวหน้าสำคัญในด้าน <span class="highlight-bold">การเคลื่อนไหวของร่างกายที่ซับซ้อน รูปแบบที่หลากหลาย การแสดงออกทางสีหน้าของตัวละครที่ละเอียดอ่อน และการตอบสนองต่อคำสั่งการเคลื่อนที่ของวัตถุ</span> <span class="highlight-bold">ทดลองใช้ฟรีตอนนี้และสัมผัสกับเสน่ห์อันทรงพลังของการสร้างวิดีโอ AI รุ่นต่อไป!</span>',
        tabImageToVideo: 'รูปภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Hailuo 2.3',
        accurateInstructionFollowingTitle: 'การควบคุมไดนามิกที่แม่นยำยิ่งขึ้นและภาพที่สมจริง',
        accurateInstructionFollowingDescription: 'โมเดลได้ปรับปรุงประสิทธิภาพทางกายภาพ.',
        extremePhysicsMotionTitle: 'การรองรับรูปแบบที่หลากหลายและทรงพลังยิ่งขึ้น',
        extremePhysicsMotionDescription: 'รองรับสไตล์ศิลปะพิเศษได้ดียิ่งขึ้น.',
        native1080pOutputTitle: 'การแสดงอารมณ์ทางสีหน้าของตัวละครที่ละเอียดขึ้น',
        native1080pOutputDescription: 'การเปลี่ยนแปลงอารมณ์ทางสีหน้ามีความเป็นธรรมชาติขึ้น.',
        costEffectiveTitle: 'การตอบสนองต่อคำสั่งเคลื่อนที่ของวัตถุที่เหนือกว่า',
        costEffectiveDescription: 'เพิ่มประสิทธิภาพสำหรับอีคอมเมิร์ซ.',
        howToUseTitle: 'วิธีการใช้งาน',
        howToUseSubtitle: 'สามขั้นตอนง่ายๆ เพื่อเริ่มการสร้างสรรค์',
        step1Title: 'เลือกโมเดล Hailuo 2.3',
        step1Description: 'ไปที่หน้า <span class="highlight-text">"การสร้างวิดีโอ AI"</span>.',
        step2Title: 'ใส่เนื้อหาที่สร้างสรรค์ของคุณ',
        step2Description: 'อธิบายสิ่งที่คุณต้องการสร้าง.',
        step3Title: 'สร้างวิดีโอ',
        step3Description: 'คลิก "สร้าง".',
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ Hailuo 2.3',
        youtubeVideosTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ Hailuo 2.3',
        youtubeVideoTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ Hailuo 2.3',
        xPostsTitle: 'โพสต์ X ยอดนิยมเกี่ยวกับโมเดลวิดีโอ Hailuo 2.3',
        exploreModelsTitle: 'สำรวจโมเดลอื่นๆ',
        sora2Title: 'เครื่องมือสร้างวิดีโอ OpenAI Sora-2 AI',
        veo31Title: 'เครื่องมือสร้างวิดีโอ Google Veo 3.1 AI',
        veo3Title: 'เครื่องมือสร้างวิดีโอ Google Veo 3 AI',
        veo3FastTitle: 'เครื่องมือสร้างวิดีโอ Google Veo 3 Fast AI',
        klingTitle: 'เครื่องมือสร้างวิดีโอ Kling AI',
        runwayTitle: 'เครื่องมือสร้างวิดีโอ Runway AI',
        wanTitle: 'เครื่องมือสร้างวิดีโอ Wan AI',
        faqTitle: 'คำถามที่พบบ่อย',
        faq1Question: '1. มีการปรับปรุงหลักอะไรบ้าง?',
        faq1Answer: 'การปรับปรุงในสี่ด้านหลัก.',
        faq2Question: '2. เหมาะสำหรับสร้างวิดีโอประเภทใด?',
        faq2Answer: 'อีคอมเมิร์ซ, อนิเมะ, ฯลฯ.',
        faq3Question: '3. โมเดล Hailuo 2.3 Fast คืออะไร?',
        faq3Answer: 'ปรับให้เหมาะสมกับความเร็ว.',
        faq4Question: '4. วิธีใช้งานโมเดล?',
        faq4Answer: 'เข้าชมเว็บไซต์.',
        faq5Question: '5. มีโอกาสทดลองใช้ฟรีหรือไม่?',
        faq5Answer: 'มี.',
        faq6Question: '6. จะรับคีย์ API ได้อย่างไร?',
        faq6Answer: 'ใช้ Media Agent.',
        faq7Question: '7. ต้นทุนสูงหรือไม่?',
        faq7Answer: 'ความคุ้มค่าที่ดีที่สุด.',
        ctaTitle: 'พร้อมที่จะเริ่มสร้างสรรค์หรือยัง?',
        ctaSubtitle: 'สัมผัสประสบการณ์ Hailuo 2.3 ตอนนี้',
        ctaDescription: 'สัมผัสประสบการณ์ Hailuo 2.3 ตอนนี้',
        ctaButton: 'ลองใช้ Hailuo 2.3 บน 微鲤AI',
        ctaNote: 'ไม่ต้องใช้บัตรเครดิต',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',
        videoNotSupported: 'เบราว์เซอร์ไม่รองรับการเล่น',
        videoUnsupported: 'เบราว์เซอร์ไม่รองรับการเล่น',
        videoLoadingError: 'การโหลดล้มเหลว',
        videoLoadError: 'ไม่สามารถโหลดได้',
        videoReload: 'โหลดใหม่',
    },
    da: {
        pageTitle: 'Hailuo 2.3 Video Generator - Innovativ AI Video Creation Platform | 微鲤AI',
        pageDescription: 'Oplev Hailuo 2.3 video generator, fokuseret på intelligent video skabelse og indholdsoptimering. Bruger avanceret deep learning teknologi til at generere kreative videoindhold af høj kvalitet. Prøv det gratis på 微鲤AI platformen.',
        pageKeywords: 'Hailuo 2.3, AI video generator, AI video skabelse, kunstig intelligens video, video genereringsværktøj, gratis AI video, 微鲤AI, video produktion',
        generatorTitle: 'Hailuo 2.3 Video Generator (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3 er en revolutionerende opgradering baseret på Hailuo 02 modellen, der opnår vigtige gennembrud inden for <span class="highlight-bold">komplekse kropsbevægelser, diversificeret stylisering, karakter mikro-udtryk og respons på objekt bevægelseskommandoer</span>. <span class="highlight-bold">Prøv det gratis nu og oplev den kraftfulde charme ved næste generations AI video skabelse!</span>',
        tabImageToVideo: 'Billede til Video',
        tabTextToVideo: 'Tekst til Video',
        coreFeaturesTitle: 'Hovedfunktioner i Hailuo 2.3',
        accurateInstructionFollowingTitle: 'Mere Præcis Dynamisk Kontrol og Realistisk Grafik',
        accurateInstructionFollowingDescription: 'Modellen har betydeligt forbedret sin fysiske ydeevne.',
        extremePhysicsMotionTitle: 'Stærkere Support for Diversificeret Stylisering',
        extremePhysicsMotionDescription: 'Bedre support til specielle kunststile.',
        native1080pOutputTitle: 'Mere Detaljeret Gengivelse af Karakter Mikro-udtryk',
        native1080pOutputDescription: 'Mikro-udtryksændringer er mere naturlige.',
        costEffectiveTitle: 'Overlegen Respons på Objekt Bevægelseskommandoer',
        costEffectiveDescription: 'Optimeret til e-handel reklame.',
        howToUseTitle: 'Sådan gør du',
        howToUseSubtitle: 'Tre enkle trin for at begynde at skabe',
        step1Title: 'Vælg Hailuo 2.3 Modellen',
        step1Description: 'Gå til siden <span class="highlight-text">"AI Video Generering"</span>.',
        step2Title: 'Indtast dit Kreative Indhold',
        step2Description: 'Beskriv hvad du vil generere.',
        step3Title: 'Generer Video',
        step3Description: 'Klik på "Opret".',
        youtubeTitle: 'YouTube Videoer Om Hailuo 2.3 Video Modellen',
        youtubeVideosTitle: 'YouTube Videoer Om Hailuo 2.3 Video Modellen',
        youtubeVideoTitle: 'YouTube Videoer Om Hailuo 2.3 Video Modellen',
        xPostsTitle: 'Populære X Indlæg Om Hailuo 2.3 Video Modellen',
        exploreModelsTitle: 'Udforsk andre modeller',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',
        faqTitle: 'Ofte Stillede Spørgsmål',
        faq1Question: '1. Hvad er de vigtigste forbedringer?',
        faq1Answer: 'Forbedringer på fire hovedområder.',
        faq2Question: '2. Hvilke typer videoer er Hailuo 2.3 velegnet til?',
        faq2Answer: 'E-handel, anime, osv.',
        faq3Question: '3. Hvad er Hailuo 2.3 Fast modellen?',
        faq3Answer: 'Optimeret til hastighed.',
        faq4Question: '4. Hvordan bruger man Hailuo 2.3 modellen?',
        faq4Answer: 'Besøg hjemmesiden.',
        faq5Question: '5. Har nye brugere mulighed for at prøve gratis?',
        faq5Answer: 'Ja.',
        faq6Question: '6. Hvordan får man API nøglen?',
        faq6Answer: 'Brug Media Agent.',
        faq7Question: '7. Er omkostningerne høje?',
        faq7Answer: 'Bedste pris-ydelses-forhold.',
        ctaTitle: 'Klar til at begynde at skabe?',
        ctaSubtitle: 'Oplev Hailuo 2.3 nu',
        ctaDescription: 'Oplev Hailuo 2.3 nu',
        ctaButton: 'Prøv Hailuo 2.3 på 微鲤AI',
        ctaNote: 'Intet kreditkort påkrævet',
        ctaDisclaimer: 'Intet kreditkort påkrævet',
        videoNotSupported: 'Browser understøtter ikke afspilning',
        videoUnsupported: 'Browser understøtter ikke afspilning',
        videoLoadingError: 'Fejl ved indlæsning',
        videoLoadError: 'Kunne ikke indlæses',
        videoReload: 'Genindlæs',
    },
    no: {
        pageTitle: 'Hailuo 2.3 Video Generator - Innovativ AI Video Creation Platform | 微鲤AI',
        pageDescription: 'Opplev Hailuo 2.3 video generator, fokusert på intelligent video skaping og innholdsoptimalisering. Bruker avansert deep learning teknologi for å generere kreative videoinnhold av høy kvalitet. Prøv det gratis på 微鲤AI plattformen.',
        pageKeywords: 'Hailuo 2.3, AI video generator, AI video skaping, kunstig intelligens video, video genereringsverktøy, gratis AI video, 微鲤AI, video produksjon',
        generatorTitle: 'Hailuo 2.3 Video Generator (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3 er en revolusjonerende oppgradering basert på Hailuo 02 modellen, som oppnår viktige gjennombrudd innen <span class="highlight-bold">komplekse kroppsbevegelser, diversifisert stylisering, karakter mikro-uttrykk og respons på objekt bevegelseskommandoer</span>. <span class="highlight-bold">Prøv det gratis nå og opplev den kraftfulle sjarmen ved neste generasjons AI video skaping!</span>',
        tabImageToVideo: 'Bilde til Video',
        tabTextToVideo: 'Tekst til Video',
        coreFeaturesTitle: 'Hovedfunksjoner i Hailuo 2.3',
        accurateInstructionFollowingTitle: 'Mer Presis Dynamisk Kontrol og Realistisk Grafikk',
        accurateInstructionFollowingDescription: 'Modellen har betydelig forbedret sin fysiske ytelse.',
        extremePhysicsMotionTitle: 'Sterkere Support for Diversifisert Stylisering',
        extremePhysicsMotionDescription: 'Bedre support for spesielle kunststiler.',
        native1080pOutputTitle: 'Mer Detaljert Gjengivelse av Karakter Mikro-uttrykk',
        native1080pOutputDescription: 'Mikro-uttrykksendringer er mer naturlige.',
        costEffectiveTitle: 'Overlegen Respons på Objekt Bevegelseskommandoer',
        costEffectiveDescription: 'Optimalisert for e-handel reklame.',
        howToUseTitle: 'Slik gjør du det',
        howToUseSubtitle: 'Tre enkle trinn for å begynne å skape',
        step1Title: 'Velg Hailuo 2.3 Modellen',
        step1Description: 'Gå til siden <span class="highlight-text">"AI Video Generering"</span>.',
        step2Title: 'Skriv inn ditt Kreative Innhold',
        step2Description: 'Beskriv hva du vil generere.',
        step3Title: 'Generer Video',
        step3Description: 'Klikk på "Opprett".',
        youtubeTitle: 'YouTube Videoer Om Hailuo 2.3 Video Modellen',
        youtubeVideosTitle: 'YouTube Videoer Om Hailuo 2.3 Video Modellen',
        youtubeVideoTitle: 'YouTube Videoer Om Hailuo 2.3 Video Modellen',
        xPostsTitle: 'Populære X Innlegg Om Hailuo 2.3 Video Modellen',
        exploreModelsTitle: 'Utforsk andre modeller',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',
        faqTitle: 'Ofte Stilte Spørsmål',
        faq1Question: '1. Hva er de viktigste forbedringene?',
        faq1Answer: 'Forbedringer på fire hovedområder.',
        faq2Question: '2. Hvilke typer videoer er Hailuo 2.3 egnet til?',
        faq2Answer: 'E-handel, anime, osv.',
        faq3Question: '3. Hva er Hailuo 2.3 Fast modellen?',
        faq3Answer: 'Optimalisert for hastighet.',
        faq4Question: '4. Hvordan bruker man Hailuo 2.3 modellen?',
        faq4Answer: 'Besøk hjemmesiden.',
        faq5Question: '5. Har nye brukere mulighet til å prøve gratis?',
        faq5Answer: 'Ja.',
        faq6Question: '6. Hvordan får man API nøkkelen?',
        faq6Answer: 'Bruk Media Agent.',
        faq7Question: '7. Er kostnadene høye?',
        faq7Answer: 'Beste pris-ytelses-forhold.',
        ctaTitle: 'Klar til å begynne å skape?',
        ctaSubtitle: 'Opplev Hailuo 2.3 nå',
        ctaDescription: 'Opplev Hailuo 2.3 nå',
        ctaButton: 'Prøv Hailuo 2.3 på 微鲤AI',
        ctaNote: 'Intet kredittkort påkrevd',
        ctaDisclaimer: 'Intet kredittkort påkrevd',
        videoNotSupported: 'Nettleseren din støtter ikke avspilling',
        videoUnsupported: 'Nettleseren din støtter ikke avspilling',
        videoLoadingError: 'Videoinnlasting mislyktes',
        videoLoadError: 'Kunne ikke lastes inn',
        videoReload: 'Last på nytt',
    },
    nl: {
        pageTitle: 'Hailuo 2.3 Video Generator - Innovatief AI Video Creatie Platform | 微鲤AI',
        pageDescription: 'Ervaar de Hailuo 2.3 video generator, gericht op intelligente video creatie en content optimalisatie. Maakt gebruik van geavanceerde deep learning technologie om creatieve video content van hoge kwaliteit te genereren. Probeer het gratis op het 微鲤AI platform.',
        pageKeywords: 'Hailuo 2.3, AI video generator, AI video creatie, kunstmatige intelligentie video, video generatie tool, gratis AI video, 微鲤AI, video productie',
        generatorTitle: 'Hailuo 2.3 Video Generator (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3 is een revolutionaire upgrade op basis van het Hailuo 02 model, waarmee belangrijke doorbraken zijn bereikt op het gebied van <span class="highlight-bold">complexe lichaamsbewegingen, diverse stijlen, micro-expressies van personages en respons op objectbewegingscommando\'s</span>. <span class="highlight-bold">Probeer het nu gratis en ervaar de krachtige charme van de volgende generatie AI video creatie!</span>',
        tabImageToVideo: 'Afbeelding naar Video',
        tabTextToVideo: 'Tekst naar Video',
        coreFeaturesTitle: 'Belangrijkste kenmerken van Hailuo 2.3',
        accurateInstructionFollowingTitle: 'Preciezere dynamische controle en realistische beelden',
        accurateInstructionFollowingDescription: 'Het model heeft zijn fysieke prestaties aanzienlijk verbeterd.',
        extremePhysicsMotionTitle: 'Krachtigere ondersteuning voor diverse stijlen',
        extremePhysicsMotionDescription: 'Betere ondersteuning voor speciale kunststijlen.',
        native1080pOutputTitle: 'Gedetailleerdere weergave van micro-expressies van personages',
        native1080pOutputDescription: 'Micro-expressie veranderingen zijn natuurlijker.',
        costEffectiveTitle: 'Superieure respons op objectbewegingscommando\'s',
        costEffectiveDescription: 'Gespecifiek geoptimaliseerd voor e-commerce.',
        howToUseTitle: 'Hoe te gebruiken',
        howToUseSubtitle: 'Drie eenvoudige stappen om te beginnen met creëren',
        step1Title: 'Selecteer het Hailuo 2.3 Model',
        step1Description: 'Ga naar de pagina <span class="highlight-text">"AI Video Generatie"</span>.',
        step2Title: 'Voer uw Creatieve Content in',
        step2Description: 'Beschrijf wat u wilt genereren.',
        step3Title: 'Genereer Video',
        step3Description: 'Klik op "Creëren".',
        youtubeTitle: 'YouTube Video\'s Over het Hailuo 2.3 Video Model',
        youtubeVideosTitle: 'YouTube Video\'s Over het Hailuo 2.3 Video Model',
        youtubeVideoTitle: 'YouTube Video\'s Over het Hailuo 2.3 Video Model',
        xPostsTitle: 'Populaire X Berichten Over het Hailuo 2.3 Video Model',
        exploreModelsTitle: 'Andere modellen verkennen',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',
        faqTitle: 'Veelgestelde Vragen',
        faq1Question: '1. Wat zijn de belangrijkste verbeteringen?',
        faq1Answer: 'Verbeteringen op vier gebieden.',
        faq2Question: '2. Voor welke soorten video\'s is Hailuo 2.3 geschikt?',
        faq2Answer: 'E-commerce, anime, enz.',
        faq3Question: '3. Wat is het Hailuo 2.3 Fast model?',
        faq3Answer: 'Geoptimaliseerd voor snelheid.',
        faq4Question: '4. Hoe gebruik ik het model?',
        faq4Answer: 'Bezoek de website.',
        faq5Question: '5. Hebben nieuwe gebruikers de mogelijkheid om gratis te proberen?',
        faq5Answer: 'Ja.',
        faq6Question: '6. Hoe krijg ik de API sleutel?',
        faq6Answer: 'Media Agent gebruiken.',
        faq7Question: '7. Zijn de kosten hoog?',
        faq7Answer: 'Beste prijs-kwaliteitverhouding.',
        ctaTitle: 'Klaar om te beginnen?',
        ctaSubtitle: 'Ervaar Hailuo 2.3 nu',
        ctaDescription: 'Ervaar Hailuo 2.3 nu',
        ctaButton: 'Probeer Hailuo 2.3 op 微鲤AI',
        ctaNote: 'Geen creditcard vereist',
        ctaDisclaimer: 'Geen creditcard vereist',
        videoNotSupported: 'Browser ondersteunt videoweergave niet',
        videoUnsupported: 'Browser ondersteunt videoweergave niet',
        videoLoadingError: 'Video laden mislukt',
        videoLoadError: 'Kon niet worden geladen',
        videoReload: 'Opnieuw laden',
    },
    id: {
        pageTitle: 'Generator Video Hailuo 2.3 - Platform Pembuatan Video AI Inovatif | 微鲤AI',
        pageDescription: 'Rasakan generator video Hailuo 2.3, yang berfokus pada pembuatan video cerdas dan optimalisasi konten. Menggunakan teknologi deep learning tingkat lanjut untuk menghasilkan konten video kreatif berkualitas tinggi. Coba gratis di platform 微鲤AI.',
        pageKeywords: 'Hailuo 2.3, generator video AI, pembuatan video AI, video kecerdasan buatan, alat pembuatan video, video AI gratis, 微鲤AI, produksi video',
        generatorTitle: 'Generator Video Hailuo 2.3 (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3 adalah peningkatan revolusioner berdasarkan model Hailuo 02, mencapai terobosan kunci dalam <span class="highlight-bold">gerakan tubuh yang kompleks, beragam stilisasi, mikro-ekspresi karakter, dan respons perintah gerakan objek</span>. <span class="highlight-bold">Coba gratis sekarang dan rasakan pesona kuat pembuatan video AI generasi berikutnya!</span>',
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',
        coreFeaturesTitle: 'Fitur Utama Hailuo 2.3',
        accurateInstructionFollowingTitle: 'Kontrol Dinamis Lebih Presisi dan Visual Realistis',
        accurateInstructionFollowingDescription: 'Model ini telah secara signifikan meningkatkan performa fisik.',
        extremePhysicsMotionTitle: 'Dukungan Beragam Stilisasi Lebih Kuat',
        extremePhysicsMotionDescription: 'Dukungan lebih baik untuk gaya seni khusus.',
        native1080pOutputTitle: 'Interpretasi Mikro-ekspresi Karakter Lebih Detail',
        native1080pOutputDescription: 'Perubahan mikro-ekspresi lebih alami.',
        costEffectiveTitle: 'Respons Perintah Gerakan Objek Unggul',
        costEffectiveDescription: 'Dioptimalkan untuk e-commerce.',
        howToUseTitle: 'Cara Menggunakan',
        howToUseSubtitle: 'Tiga langkah sederhana untuk mulai membuat',
        step1Title: 'Pilih Model Hailuo 2.3',
        step1Description: 'Buka halaman <span class="highlight-text">"Pembuatan Video AI"</span>.',
        step2Title: 'Masukkan Konten Kreatif Anda',
        step2Description: 'Deskripsikan apa yang ingin Anda buat.',
        step3Title: 'Hasilkan Video',
        step3Description: 'Klik "Buat".',
        youtubeTitle: 'Video YouTube Tentang Model Video Hailuo 2.3',
        youtubeVideosTitle: 'Video YouTube Tentang Model Video Hailuo 2.3',
        youtubeVideoTitle: 'Video YouTube Tentang Model Video Hailuo 2.3',
        xPostsTitle: 'Postingan X Populer Tentang Model Video Hailuo 2.3',
        exploreModelsTitle: 'Jelajahi model lain',
        sora2Title: 'Generator Video OpenAI Sora-2 AI',
        veo31Title: 'Generator Video Google Veo 3.1 AI',
        veo3Title: 'Generator Video Google Veo 3 AI',
        veo3FastTitle: 'Generator Video Google Veo 3 Fast AI',
        klingTitle: 'Generator Video Kling AI',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Generator Video Wan AI',
        faqTitle: 'Pertanyaan yang Sering Diajukan',
        faq1Question: '1. Apa peningkatan utama?',
        faq1Answer: 'Peningkatan di empat bidang.',
        faq2Question: '2. Untuk jenis video apa cocok?',
        faq2Answer: 'E-commerce, anime, dll.',
        faq3Question: '3. Apa itu model Hailuo 2.3 Fast?',
        faq3Answer: 'Dioptimalkan untuk kecepatan.',
        faq4Question: '4. Bagaimana cara menggunakan model?',
        faq4Answer: 'Kunjungi situs resmi.',
        faq5Question: '5. Apakah ada kesempatan mencoba gratis?',
        faq5Answer: 'Ya.',
        faq6Question: '6. Bagaimana cara mendapatkan kunci API?',
        faq6Answer: 'Media Agent.',
        faq7Question: '7. Apakah biaya tinggi?',
        faq7Answer: 'Efektivitas biaya terbaik.',
        ctaTitle: 'Siap untuk Mulai Membuat?',
        ctaSubtitle: 'Rasakan Hailuo 2.3 sekarang',
        ctaDescription: 'Rasakan Hailuo 2.3 sekarang',
        ctaButton: 'Coba Hailuo 2.3 di 微鲤AI',
        ctaNote: 'Tidak perlu kartu kredit',
        ctaDisclaimer: 'Tidak perlu kartu kredit',
        videoNotSupported: 'Browser Anda tidak mendukung pemutaran',
        videoUnsupported: 'Browser Anda tidak mendukung pemutaran',
        videoLoadingError: 'Pemuatan gagal',
        videoLoadError: 'Video gagal dimuat',
        videoReload: 'Muat ulang',
    },
    tr: {
        pageTitle: 'Hailuo 2.3 Video Oluşturucu - Yenilikçi Yapay Zeka Video Oluşturma Platformu | 微鲤AI',
        pageDescription: 'Akıllı video oluşturma ve içerik optimizasyonuna odaklanan Hailuo 2.3 video oluşturucuyu deneyimleyin. Yüksek kaliteli, yaratıcı video içerikleri oluşturmak için gelişmiş derin öğrenme teknolojisini kullanır. 微鲤AI platformunda ücretsiz deneyin.',
        pageKeywords: 'Hailuo 2.3, yapay zeka video oluşturucu, yapay zeka video oluşturma, yapay zeka video, video oluşturma aracı, ücretsiz yapay zeka videosu, 微鲤AI, video üretimi',
        generatorTitle: 'Hailuo 2.3 Video Oluşturucu (MiniMax)',
        generatorDescription: 'MiniMax Hailuo 2.3, Hailuo 02 modeline dayanan devrim niteliğinde bir yükseltmedir ve <span class="highlight-bold">karmaşık vücut hareketleri, çeşitli stillendirme, karakter mikro ifadeleri ve nesne hareket komutu yanıtı</span> konularında temel atılımlar gerçekleştirmiştir. <span class="highlight-bold">Şimdi ücretsiz deneyin ve yeni nesil yapay zeka video oluşturmanın güçlü cazibesini yaşayın!</span>',
        tabImageToVideo: 'Görselden Videoya',
        tabTextToVideo: 'Metinden Videoya',
        coreFeaturesTitle: 'Hailuo 2.3 Temel Özellikleri',
        accurateInstructionFollowingTitle: 'Daha Hassas Dinamik Kontrol ve Gerçekçi Görseller',
        accurateInstructionFollowingDescription: 'Model, fiziksel performansını önemli ölçüde geliştirmiştir.',
        extremePhysicsMotionTitle: 'Daha Güçlü Çeşitli Stillendirme Desteği',
        extremePhysicsMotionDescription: 'Anime, illüstrasyon, vb. için daha iyi destek.',
        native1080pOutputTitle: 'Daha Ayrıntılı Karakter Mikro İfade Performansı',
        native1080pOutputDescription: 'Mikro ifade değişiklikleri daha doğal.',
        costEffectiveTitle: 'Üstün Nesne Hareket Komutu Yanıtı',
        costEffectiveDescription: 'E-ticaret reklamları için optimize edilmiştir.',
        howToUseTitle: 'Nasıl Kullanılır',
        howToUseSubtitle: 'Oluşturmaya başlamak için üç basit adım',
        step1Title: 'Hailuo 2.3 Modelini Seçin',
        step1Description: 'Gidin <span class="highlight-text">"Yapay Zeka Video Oluşturma"</span> sayfasına.',
        step2Title: 'Yaratıcı İçeriğinizi Girin',
        step2Description: 'Oluşturmak istediğiniz şeyi açıklayın.',
        step3Title: 'Video Oluştur',
        step3Description: 'Tıklayın "Oluştur".',
        youtubeTitle: 'Hailuo 2.3 Video Modeli Hakkında YouTube Videoları',
        youtubeVideosTitle: 'Hailuo 2.3 Video Modeli Hakkında YouTube Videoları',
        youtubeVideoTitle: 'Hailuo 2.3 Video Modeli Hakkında YouTube Videoları',
        xPostsTitle: 'Hailuo 2.3 Video Modeli Hakkında Popüler X Gönderileri',
        exploreModelsTitle: 'Diğer modelleri keşfedin',
        sora2Title: 'OpenAI Sora-2 Yapay Zeka Video Oluşturucu',
        veo31Title: 'Google Veo 3.1 Yapay Zeka Video Oluşturucu',
        veo3Title: 'Google Veo 3 Yapay Zeka Video Oluşturucu',
        veo3FastTitle: 'Google Veo 3 Fast Yapay Zeka Video Oluşturucu',
        klingTitle: 'Kling Yapay Zeka Video Oluşturucu',
        runwayTitle: 'Runway Yapay Zeka Video Oluşturucu',
        wanTitle: 'Wan Yapay Zeka Video Oluşturucu',
        faqTitle: 'Sıkça Sorulan Sorular',
        faq1Question: '1. Temel iyileştirmeler nelerdir?',
        faq1Answer: 'Dört ana alanda iyileştirmeler.',
        faq2Question: '2. Ne tür videolar için uygundur?',
        faq2Answer: 'E-ticaret, anime, vb.',
        faq3Question: '3. Hailuo 2.3 Fast modeli nedir?',
        faq3Answer: 'Hız için optimize edilmiş.',
        faq4Question: '4. Nasıl kullanılır?',
        faq4Answer: 'Web sitesini ziyaret edin.',
        faq5Question: '5. Ücretsiz deneme şansı var mı?',
        faq5Answer: 'Evet.',
        faq6Question: '6. API anahtarını nasıl alabilirim?',
        faq6Answer: 'Media Agent kullanın.',
        faq7Question: '7. Maliyet yüksek mi?',
        faq7Answer: 'En iyi maliyet etkinliği.',
        ctaTitle: 'Oluşturmaya Başlamaya Hazır mısınız?',
        ctaSubtitle: 'Hailuo 2.3’ü şimdi deneyimleyin',
        ctaDescription: 'Hailuo 2.3’ü şimdi deneyimleyin',
        ctaButton: '微鲤AI’da Hailuo 2.3’ü Deneyin',
        ctaNote: 'Kredi kartı gerekmez',
        ctaDisclaimer: 'Kredi kartı gerekmez',
        videoNotSupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoUnsupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoLoadingError: 'Yükleme başarısız',
        videoLoadError: 'Video yüklenemedi',
        videoReload: 'Yeniden Yükle',
    }};
